window.theme = window.theme || {};
window.slate = window.slate || {};

var prevArrowSVG = '<button class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="53" height="53" viewBox="0 0 53 53"><title>cirlce-arrow-left</title><g id="Layer_2" data-name="Layer 2"><g id="text"><path d="M26.5,53A26.5,26.5,0,1,1,53,26.5,26.53,26.53,0,0,1,26.5,53Zm0-52A25.5,25.5,0,1,0,52,26.5,25.53,25.53,0,0,0,26.5,1Z" fill="#474d55"/><rect x="17.13" y="26.09" width="19.5" height="1" fill="#474d55"/><rect x="20.66" y="24.81" width="1" height="10.88" transform="translate(-15.19 23.82) rotate(-45)" fill="#474d55"/><rect x="15.72" y="22.25" width="10.88" height="1" transform="translate(-9.89 21.63) rotate(-45)" fill="#474d55"/></g></g></svg></button>',
    nextArrowSVG = '<button class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="53" height="53" viewBox="0 0 53 53"><title>circle-arrow-right</title><g id="Layer_2" data-name="Layer 2"><g id="text"><path d="M26.5,53A26.5,26.5,0,1,1,53,26.5,26.53,26.53,0,0,1,26.5,53Zm0-52A25.5,25.5,0,1,0,52,26.5,25.53,25.53,0,0,0,26.5,1Z" fill="#474d55"/><rect x="16.38" y="26.09" width="19.5" height="1" fill="#474d55"/><rect x="26.4" y="29.75" width="10.88" height="1" transform="translate(-12.06 31.37) rotate(-45)" fill="#474d55"/><rect x="31.34" y="17.31" width="1" height="10.88" transform="translate(-6.76 29.18) rotate(-45)" fill="#474d55"/></g></g></svg></button>';

//add simple support for background images:
document.addEventListener('lazybeforeunveil', function(e){
  var bg = e.target.getAttribute('data-bg');
  if(bg){
    e.target.style.backgroundImage = 'url(' + bg + ')';
  }
});
//console.log(allColors);

var addToCart = theme.strings.addToCart,
    preOrder = theme.strings.preOrder,
    preOrderText = theme.strings.preOrderText;


var Shopify = Shopify || {};

Shopify.optionsMap = {};

Shopify.handleize = function (str) {
  return str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
};

Shopify.updateOptionsInSelector = function(selectorIndex) {
  switch (selectorIndex) {
    case 0:
      var key = 'root';
      var selector = jQuery('.single-option-selector:eq(0)');
      break;
    case 1:
      var key = jQuery('.single-option-selector:eq(0)').val();
      var selector = jQuery('.single-option-selector:eq(1)');
      break;
    case 2:
      var key = jQuery('.single-option-selector:eq(0)').val();  
      key += ' / ' + jQuery('.single-option-selector:eq(1)').val();
      var selector = jQuery('.single-option-selector:eq(2)');
  }

  var initialValue = selector.val();
  selector.empty();    
  var availableOptions = Shopify.optionsMap[key];
  if(availableOptions) {
    for (var i=0; i<availableOptions.length; i++) {
      var option = availableOptions[i];
      var newOption = jQuery('<option></option>').val(option).html(option);
      selector.append(newOption);
    }
  }
  jQuery('.swatch[data-option-index="' + selectorIndex + '"] .swatch-element').each(function() {
    if (jQuery.inArray($(this).attr('data-value'), availableOptions) !== -1) {
      $(this).addClass('available').find(':radio').removeAttr('checked');
      //console.log('variant available');
    } else {
      $(this).removeClass('available').find(':radio').removeAttr('checked');
      //console.log('variant sold out');
    }
  });
  if (jQuery.inArray(initialValue, availableOptions) !== -1) {
    selector.val(initialValue);
  }
  selector.trigger('change');    
};

Shopify.linkOptionSelectors = function(product) {

  //console.log(product);
  // Building our mapping object.
  for (var i=0; i<product.variants.length; i++) {
    var variant = product.variants[i];

    if (variant.available) {
      // Gathering values for the 1st drop-down.
      Shopify.optionsMap['root'] = Shopify.optionsMap['root'] || [];
      Shopify.optionsMap['root'].push(variant.option1);
      Shopify.optionsMap['root'] = jQuery.unique(Shopify.optionsMap['root']);


      // Gathering values for the 2nd drop-down.
      if (product.options.length > 1) {
        var key = variant.option1;
        Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
        Shopify.optionsMap[key].push(variant.option2);
        Shopify.optionsMap[key] = jQuery.unique(Shopify.optionsMap[key]);
        //console.log(variant);
      }
      // Gathering values for the 3rd drop-down.
      if (product.options.length === 3) {
        var key = variant.option1 + ' / ' + variant.option2;
        Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
        Shopify.optionsMap[key].push(variant.option3);
        Shopify.optionsMap[key] = jQuery.unique(Shopify.optionsMap[key]);
      }
    }
  }
  // Update options right away.
  Shopify.updateOptionsInSelector(0);
  if (product.options.length > 1) Shopify.updateOptionsInSelector(1);
  if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
  // When there is an update in the first dropdown.
  jQuery(".single-option-selector:eq(0)").change(function() {
    Shopify.updateOptionsInSelector(1);
    if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
    return true;
  });
  // When there is an update in the second dropdown.
  jQuery(".single-option-selector:eq(1)").change(function() {
    if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
    return true;
  });  
};

String.prototype.imgURL = function(size) {
  // remove any current image size then add the new image size
  return this
  .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, '.')
  .replace(/\.jpg|\.png|\.gif|\.jpeg/g, function(match) {
    return '_'+size+match;
  })
  ;
};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
  .on('shopify:section:load', this._onSectionLoad.bind(this))
  .on('shopify:section:unload', this._onSectionUnload.bind(this))
  .on('shopify:section:select', this._onSelect.bind(this))
  .on('shopify:section:deselect', this._onDeselect.bind(this))
  .on('shopify:block:select', this._onBlockSelect.bind(this))
  .on('shopify:block:deselect', this._onBlockDeselect.bind(this))
  .on('shopify:section:select', function(evt) {
    if (evt.detail.sectionId !== 'sidebar-menu') {
      theme.LeftDrawer.close();
    }
  });
};

var cart;
var collection_cookie;


function getUrlParameter(name) {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  var results = regex.exec(location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

function slugify(text) {
  return text.toString().toLowerCase().trim()
  .replace(/\s+/g, '-')           // Replace spaces with -
  .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
  .replace(/\-\-+/g, '-')         // Replace multiple - with single -
  .replace(/^-+/, '')             // Trim - from start of text
  .replace(/-+$/, '');            // Trim - from end of text
}


function sort_id(a, b){
  return ($(b).attr('id')) < ($(a).attr('id')) ? 1 : -1;
}
function sort_value(a, b){
  return ($(b).attr('value')) < ($(a).attr('value')) ? 1 : -1;
}
function sort_name(a, b){
  return ($(b).data('name')) < ($(a).data('name')) ? 1 : -1;
}

var smallScreen = false;
theme.isMobile = function() {
  var isMobile = false;
  if($(window).width() <= 768) {
    isMobile = true;
    smallScreen = true;
  } 
  return isMobile;
}

theme.removeCookies = function() {
  if(getUrlParameter('clearcookies') != '') {
    Object.keys(Cookies.get()).forEach(function(cookie) {
      Cookies.remove(cookie);
    });
  }
};

theme.currencySwitcher = (function() {

  var selectors = {
    dataDiv: '#CurrencyData',
    picker: '.currency-input',
    list: '.currency-picker',
    flag: '.currency-flag',
    current: '.currency-picker__current'
  };

  var data = {};

  function init() {
    var $dataDiv = $(selectors.dataDiv);

    if (!$dataDiv.length) {
      return;
    }

    //$(selectors.picker).selectric();

    $primaryPicker = $('#CurrencyPicker-header');
    $secondaryPicker = $('#CurrencyPicker-footer');

    // Keep primary and secondary currency pickers in sync
    if ($secondaryPicker.length) {
      $secondaryPicker.on('change', function() {
        $primaryPicker.val($(this).val());
      });

      $primaryPicker.on('change', function() {
        $secondaryPicker.val($(this).val());
      });
    }



    data = {
      currency: $dataDiv.data('shop-currency'),
      default: $dataDiv.data('default-currency'),
      format: $dataDiv.data('format'),
      moneyFormat: $dataDiv.data('money-format'),
      moneyCurrencyFormat: $dataDiv.data('money-currency-format')
    };

    Currency.format = data.format;

    // Rely on the shop's currency format, not Shopify defaults (in case merchant changes it)
    //Currency.money_format[data.currency] = data.moneyFormat;
    //Currency.money_with_currency_format[data.currency] = data.moneyCurrencyFormat;

    // Fix for customer account page
    $('span.money span.money').each(function() {
      $(this).parents('span.money').removeClass('money');
    });

    // Save current price
    $('span.money').each(function() {
      $(this).attr('data-currency-' + data.currency, $(this).html());
    });

    checkCookie();

    $(selectors.picker).val(Currency.currentCurrency).on('change', refresh);

    $(selectors.flag).on('click',function(e) {
      e.preventDefault();
      newCurrency = $(this).data('currency');
      //Currency.convertAll(Currency.currentCurrency, newCurrency);
      $(selectors.picker + ' option').prop('selected',false);
      $(selectors.picker + ' option[value="'+newCurrency+'"]').prop('selected',true).trigger('change');
      updateCurrencyList(newCurrency);

    });


  }

  function refresh() {
    var newCurrency = $(selectors.picker).val();
    Currency.convertAll(Currency.currentCurrency, newCurrency);
  }

  function ajaxrefresh() {
    var newCurrency = $(selectors.picker).val();
    // Ajax cart always returns shop's currency, not what theme settings defines
    Currency.convertAll(data.currency, newCurrency);
  }

  function checkCookie() {
    var cookieCurrency = Currency.cookie.read();
    //var cookieCurrency = null;

    if (cookieCurrency == null) {
      if (data.currency !== data.default) {
        Currency.convertAll(data.currency, data.default);
      }
      else {
        Currency.currentCurrency = data.default;
      }
    } else if ($(selectors.picker).length && $(selectors.picker).find('option[value=' + cookieCurrency + ']').length === 0) {
      // If the cookie value does not correspond to any value in the currency dropdown
      Currency.currentCurrency = data.currency;
      Currency.cookie.write(data.currency);
    }
    else if (cookieCurrency === data.currency) {
      Currency.currentCurrency = data.currency;
    }
    else {
      Currency.convertAll(data.currency, cookieCurrency);
      updateCurrencyList(cookieCurrency);

    }
  }

  function updateCurrencyList(currency) {
    $(selectors.flag).parent().removeClass('hide');
    $(selectors.current + ' span')
    .removeClass()
    .addClass('currency-flag')
    .addClass('currency-flag-'+currency.toLowerCase());
    $(selectors.list + ' ' + selectors.flag + '.currency-flag-' + currency.toLowerCase()).parent().addClass('hide');
  }

  return {
    init: init,
    refresh: refresh,
    ajaxrefresh: ajaxrefresh
  };
})();

theme.FancySwatches = function () {

  var product = $('.product-container'),
      swatchList = $('<div id="color-swatches-search"></div>'),
      swatchWrapper = $('<div id="color-swatches-search-wrapper"></div>'),
      fullTitle = product.data('full-title'),
      noColorTitle = product.data('title').trim().replace('&trade;',''),
      termHandle = noColorTitle.toLowerCase().replace(/ /g,'-'),
      currentColor = product.data('color').trim(),
      term = $.trim(noColorTitle).toLowerCase().split(' ').join('+'),

      searchURL = '/search?q=' + term + '&type=product&view=colors',
      splitValue = '|';
      if(theme.dev.otherColors) {

        swatchWrapper.append(swatchList).insertBefore(product.find('.product-form')),
          swatchWrapper.prepend('<div class="header">Color: <span class="selected">'+currentColor+'</span></div>');

        if(fullTitle.indexOf(splitValue) > 1) {
          $.getJSON(searchURL, function(data) {
            //console.log(data);
            if(data.results_count > 0) {
              $.each(data.results, function(index, item) {
                if(item.title == noColorTitle) {
                  if(item.color == currentColor) {
                    var activeClass = 'class="color-swatch active lazyfade lazyload"';
                  } else {
                    var activeClass = 'class="color-swatch lazyfade lazyload"';
                  }
                  if(item.hex) {
                    var swatch = '<a href="'+item.url+'" '+activeClass+' data-tooltip="'+item.color+'" style="background-color:'+item.hex+'"></a>';
                  } else if(item.image) {
                    var swatch = '<a href="'+item.url+'" '+activeClass+' data-tooltip="'+item.color+'" data-bg="'+item.image+'"></a>';
                  }
                  swatchList.append(swatch);

                }
              });
              if(swatchList.children().length > 0) {
                swatchWrapper.fadeIn();
                $('.swatch.Color').hide();
              }
            }
          });
        }
      }
};



theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(
      function(index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  }
});

window.slate = window.slate || {};

/**
 * Slate utilities
 * -----------------------------------------------------------------------------
 * A collection of useful utilities to help build your theme
 *
 *
 * @namespace utils
 */

slate.utils = {
  keyboardKeys: {
    TAB: 9
  }
};

window.slate = window.slate || {};

/**
 * iFrames
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace iframes
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    options.$tables.wrap(
      '<div class="' + options.tableWrapperClass + '"></div>'
    );
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + options.iframeWrapperClass + '"></div>');

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

window.slate = window.slate || {};

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';
    var focusClass = '';

    $element
    .first()
    .attr('tabIndex', '-1')
    .focus()
    .addClass(focusClass)
    .one('blur', callback);

    function callback() {
      $element
      .first()
      .removeClass(focusClass)
      .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on(
      'click',
      function(evt) {
        this.pageLinkFocus($(evt.currentTarget.hash));
      }.bind(this)
    );
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventsName = {
      focusin: options.namespace ? 'focusin.' + options.namespace : 'focusin',
      focusout: options.namespace
      ? 'focusout.' + options.namespace
      : 'focusout',
      keydown: options.namespace
      ? 'keydown.' + options.namespace
      : 'keydown.handleFocus'
    };

    /**
     * Get every possible visible focusable element
     */
    var $focusableElements = options.$container.find(
      $(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
      ).filter(':visible')
    );
    var firstFocusable = $focusableElements[0];
    var lastFocusable = $focusableElements[$focusableElements.length - 1];

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    function _manageFocus(evt) {
      if (evt.keyCode !== slate.utils.keyboardKeys.TAB) return;

      /**
       * On the last focusable element and tab forward,
       * focus the first element.
       */
      if (evt.target === lastFocusable && !evt.shiftKey) {
        evt.preventDefault();
        firstFocusable.focus();
      }
      /**
       * On the first focusable element and tab backward,
       * focus the last element.
       */
      if (evt.target === firstFocusable && evt.shiftKey) {
        evt.preventDefault();
        lastFocusable.focus();
      }
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).off('focusin');

    $(document).on(eventsName.focusout, function() {
      $(document).off(eventsName.keydown);
    });

    $(document).on(eventsName.focusin, function(evt) {
      if (evt.target !== lastFocusable && evt.target !== firstFocusable) return;

      $(document).on(eventsName.keydown, function(evt) {
        _manageFocus(evt);
      });
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
    ? 'focusin.' + options.namespace
    : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  },

  /**
   * Add aria-describedby attribute to external and new window links
   *
   * @param {object} options - Options to be used
   * @param {object} options.messages - Custom messages to be used
   * @param {jQuery} options.$links - Specific links to be targeted
   */
  accessibleLinks: function(options) {
    var body = document.querySelector('body');

    var idSelectors = {
      newWindow: 'a11y-new-window-message',
      external: 'a11y-external-message',
      newWindowExternal: 'a11y-new-window-external-message'
    };

    if (options.$links === undefined || !options.$links.jquery) {
      options.$links = $('a:not([aria-describedby])');
    }

    function generateHTML(customMessages) {
      if (typeof customMessages !== 'object') {
        customMessages = {};
      }

      var messages = $.extend(
        {
          newWindow: 'Opens in a new window.',
          external: 'Opens external website.',
          newWindowExternal: 'Opens external website in a new window.'
        },
        customMessages
      );

      var container = document.createElement('ul');
      var htmlMessages = '';

      for (var message in messages) {
        htmlMessages +=
          '<li id=' + idSelectors[message] + '>' + messages[message] + '</li>';
      }

      container.setAttribute('hidden', true);
      container.innerHTML = htmlMessages;

      body.appendChild(container);
    }

    function _externalSite($link) {
      var hostname = window.location.hostname;

      return $link[0].hostname !== hostname;
    }

    $.each(options.$links, function() {
      var $link = $(this);
      var target = $link.attr('target');
      var rel = $link.attr('rel');
      var isExternal = _externalSite($link);
      var isTargetBlank = target === '_blank';

      if (isExternal) {
        $link.attr('aria-describedby', idSelectors.external);
      }
      if (isTargetBlank) {
        if (rel === undefined || rel.indexOf('noopener') === -1) {
          $link.attr('rel', 'noopener');
        }
        $link.attr('aria-describedby', idSelectors.newWindow);
      }
      if (isExternal && isTargetBlank) {
        $link.attr('aria-describedby', idSelectors.newWindowExternal);
      }
    });

    generateHTML(options.messages);
  }
};

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

theme.Images = (function() {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Swaps the src of an image for another OR returns the imageURL to the callback function
   * @param image
   * @param element
   * @param callback
   */
  function switchImage(image, element, callback) {
    var size = this.imageSize(element.src);
    var imageUrl = this.getSizedImageUrl(image.src, size);

    if (callback) {
      callback(imageUrl, image, element); // eslint-disable-line callback-return
    } else {
      element.src = imageUrl;
    }
  }

  /**
   * +++ Useful
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/
    );

    if (match !== null) {
      if (match[2] !== undefined) {
        return match[1] + match[2];
      } else {
        return match[1];
      }
    } else {
      return null;
    }
  }

  /**
   * +++ Useful
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match !== null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    }

    return null;
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    switchImage: switchImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = (function() {
  var moneyFormat = '$'; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.  Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();
    this.variantStyle = $(this.$container).data('variant-style');

    $(this.singleOptionSelector, this.$container).on(
      'change',
      this._onSelectChange.bind(this)
    );


    $(this.singleOptionSelector, this.$container).trigger('change');

    if(this.variantStyle == 'swatch') {
      $(this.singleOptionSelector, this.$container).closest('form').find('.selector-wrapper').hide();
      $('.swatch :radio').change(function() {
        var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
        var optionValue = jQuery(this).val();
        $(this)
        .closest('form')
        .find('.single-option-selector')
        .eq(optionIndex)
        .val(optionValue)
        .trigger('change');
      });
      $(".swatch .custom_swatch_main :radio").change(function(){
              var product_url = $(".bundle_template select.product-form__variants option:selected").attr("data-url");
          jQuery.ajax({
    type: 'GET',
    url: product_url,
    dataType: 'html',
    success: function(html_data){  
      $('.grid__item.product-single__photos.medium-up--one-half').html($(html_data).find('.grid__item.product-single__photos.medium-up--one-half').html());
           $("#product-slick").show();
                    if($('.rocker-thumbnails__image-wrap').length == 1){
  var get_length = $(".product_gallery_images").val();
if (typeof get_length === "undefined") {
var slides_show = 4;
    // ...
}else{
var set_slide = parseInt(get_length);
var slides_show  = get_length - 1 ;
}
$("div#custom_pro_slide").slick({
          dots: false,
          arrows: false,
          swipeToSlide: true,
          draggable:true,
          accessibility: false,
          speed: 500,
          fade: true,
          asNavFor: '.custom_main_rockers-bundle'
        });



        $('.custom_main_rockers-bundle').slick({
          arrows: true,
          slidesToShow: 4,
          slidesToScroll: 1,
          vertical: true,
          verticalScrolling: false,
          asNavFor: "div#custom_pro_slide",
          focusOnSelect: true,
          responsive: [
            {
              breakpoint: 779,
              settings: {
                arrows: true,
                slidesToScroll: 1,
                slidesToShow: 4,
                vertical: false,
                asNavFor: "div#custom_pro_slide",
                focusOnSelect: true
              }
            }
          ]
        });



      }
      else if($('.newrocker-thumbnails__image-wrap').length == 1){
        $("div#custom_pro_slide").slick({
          dots: false,
          arrows: false,
          swipeToSlide: true,
          accessibility: false,
          speed: 500,
          fade: true,
          asNavFor: '.custom_main_rockers-bundle'
        });

        $('.custom_main_rockers-bundle').slick({
          arrows: true,
          slidesToShow: 4,
          slidesToScroll: 1,
          vertical: true,
          verticalScrolling: false,
          asNavFor: "div#custom_pro_slide",
          focusOnSelect: true,
          responsive: [
            {
              breakpoint: 779,
              settings: {
                arrows: true,
                slidesToScroll: 1,
                slidesToShow: 4,
                vertical: false,
                asNavFor: "div#custom_pro_slide",
                focusOnSelect: true
              }
            }
          ]
        });
      }
      else{
        $("div#custom_pro_slide").slick({
          dots: true,
          arrows: false,
          swipe: true,
          swipeToSlide: true,
          touchMove: true,
          draggable: true,
          accessibility: false
          // mobileFirst: true,
          // responsive: [
          //   {
          //     breakpoint: 1050,
          //     settings: {
          //       arrows: true
          //     }
          //   }
          // ]
          //prevArrow: '<button type="button" class="slick-prev"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><defs><style>.cls-1{fill:#231f20}</style></defs><path class="cls-1" d="M437.67 129.51a35 35 0 0 1 24.75 59.75L272.67 379l189.75 189.74a35 35 0 1 1-49.5 49.5L198.43 403.75a35 35 0 0 1 0-49.5l214.49-214.49a34.89 34.89 0 0 1 24.75-10.25z" transform="translate(-188.18 -129.51)" fill="#000000"/></svg></button>',
          //nextArrow: '<button type="button" class="slick-next"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 284.49 498.98"><defs><style>.cls-1{fill:#231f20}</style></defs><path class="cls-1" d="M223.18 628.49a35 35 0 0 1-24.75-59.75L388.17 379 198.43 189.26a35 35 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L247.93 618.24a34.89 34.89 0 0 1-24.75 10.25z" transform="translate(-188.18 -129.51)" fill="#000000"/></svg></button>'
        });

      }
$(".js-zoom-enabled").each(function(){
var zoomUrl = $(this).data('zoom');
    $(this).zoom({
      url: zoomUrl
    });
    });
    },
  });
      });
      //console.log('boom swatches');
    }

  }

  Variants.prototype = _.assignIn({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = _.map(
        $(this.singleOptionSelector, this.$container),
        function(element) {
          var $element = $(element);
          var type = $element.attr('type');
          var currentOption = {};

          if (type === 'radio' || type === 'checkbox') {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data('index');

              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          }
        }
      );

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = _.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;

      var found = _.find(variants, function(variant) {
        return selectedValues.every(function(values) {
          return _.isEqual(variant[values.index], values.value);
        });
      });

      return found;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }
      if(variant.featured_image) {
        const thisSlide = $(`[data-slide-image-id='${variant.featured_image.id}']`);
        if(thisSlide && thisSlide.closest("slick-slide")) {
          const thisSlideIndex = thisSlide.closest(".slick-slide").data("slick-index");
          if(typeof $('#product-slick').slick != "undefinded") {
            $('#product-slick').slick('slickGoTo',thisSlideIndex);
          }
        }
      }
      // BEGIN SWATCHES
      var selector = this.originalSelectorId;
      if (variant) {
        var form = $(selector).closest('form');
        for (var i=0,length=variant.options.length; i<length; i++) {
          var radioButton = form.find('.swatch[data-option-index="' + i + '"] :radio[value="' + variant.options[i] +'"]');
          if (radioButton.size()) {
            radioButton.get(0).checked = true;
            form.find('.swatch[data-option-index="' + i + '"] .header .selected').text(radioButton.val());
          }   
        }
      }
      // END SWATCHES
      //$(this).is('[data-specs]')
      if(variant.featured_image && variant.featured_image.alt && $('.product-template__container').is('[data-has-color-variants]') ) {
        var variantImageAlt = '.filter-'+variant.featured_image.alt.replace('-','').replace(/\s+/g, '-').replace('è','e').toLowerCase() || {};
        var slider = this.$container.find('.slick-slider');
        var colorIndex = slider.find(variantImageAlt).eq(0).parent().parent().data('slick-index');
        $('#product-slick').slick('slickGoTo',colorIndex);
        //console.log(colorIndex);
        //$('#product-slick').slick('slickUnfilter');
        //$('#product-slick').slick('slickFilter',variantImageAlt);

      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this.currentVariant = variant;
      this._updatePreOrder(variant);



      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};
      /*
      if(variantImage && variant.image.alt.length) {
      	var variantImageAlt = '.filter-'+variant.featured_image.alt.replace('-','').replace(/\s+/g, '-').toLowerCase() || {};

        var slider = this.$container.find('.slick-slider');
        var colorIndex = slider.find(variantImageAlt).eq(0).index();

        $('#product-slick').slick('slickUnfilter');
        $('#product-slick').slick('slickFilter',variantImageAlt);
      }
      */

      if (
        !variant.featured_image ||
        variantImage.src === currentVariantImage.src
      ) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });


    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price
      ) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant sku changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
    _updateSKU: function(variant) {
      if (variant.sku === this.currentVariant.sku) {

        return;
      }

      this.$container.trigger({
        type: 'variantSKUChange',
        variant: variant
      });
    },

    _updatePreOrder: function(variant) {
      if($('.product-template__container').data('pre-order-tag-multiple') == true) {
        $('.pre-order--text').hide();
        $('.pre-order--text-'+variant.id).show();
      }
      //if (variant.id === this.currentVariant.sku) {

    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl =
          window.location.protocol +
          '//' +
          window.location.host +
          window.location.pathname +
          '?variant=' +
          variant.id;
      window.history.replaceState({ path: newurl }, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container).val(variant.id);
    }
  });

  return Variants;
})();


/* ================ GLOBAL ================ */
/*============================================================================
  Drawer modules
==============================================================================*/
theme.Drawers = (function() {
  var Drawer = function(id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.nodes = {
      $parent: $('body'),
      $page: $('#PageContainer'),
      $header: $('.drawer__header'),
      $inner: $('.drawer__inner'),
      $bg: $('.open-drawer-bg')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  };

  Drawer.prototype.init = function() {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.on('click', this.config.close, $.proxy(this.close, this));
    this.nodes.$bg.on('click',$.proxy(this.close,this));
  };

  Drawer.prototype.open = function(evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Run function when draw opens if set
    if (
      this.config.beforeDrawerOpen &&
      typeof this.config.beforeDrawerOpen === 'function'
    ) {
      if (!externalCall) {
        this.config.beforeDrawerOpen();
      }
    }

    // Without this, the drawer opens, the click event bubbles up to $nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$drawer.prepareTransition();


    this.nodes.$parent.addClass(
      this.config.openClass + ' ' + this.config.dirOpenClass
    );
    $('html').addClass(this.config.openClass);
    $(".explore_benefits_links.mobile_only").slideUp();
    //     var h = $('#shopify-section-header').outerHeight();
    var t = $('.announcement-bar').outerHeight();
    var s = $('header.site-header').outerHeight();
    var h = t+s;
    if($(this.$drawer).hasClass('drawer--left')) {
      this.nodes.$inner.css('padding-top',h);
      this.nodes.$inner.css('top',0);
    }
    if($(this.$drawer).hasClass('drawer--right')) {
      h = $(this.$drawer).find('.drawer__header').outerHeight();
      this.nodes.$inner.css('top',h);
    }

    this.drawerIsOpen = true;

    // Set focus on drawer
    this.trapFocus({
      $container: this.$drawer,
      $elementToFocus: this.$drawer.find('.drawer__close-button'),
      namespace: 'drawer_focus'
    });



    // Run function when draw opens if set
    if (
      this.config.onDrawerOpen &&
      typeof this.config.onDrawerOpen === 'function'
    ) {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.nodes.$parent.on(
      'keyup.drawer',
      $.proxy(function(evt) {
        // close on 'esc' keypress
        if (evt.keyCode !== 27) return;

        this.close();
      }, this)
    );

    // Lock scrolling on mobile
    this.nodes.$page.on('touchmove.drawer', function() {
      return false;
    });

    this.nodes.$page.on(
      'click.drawer',
      $.proxy(function() {
        this.close();
        return false;
      }, this)
    );
  };

  Drawer.prototype.close = function() {
    if (!this.drawerIsOpen) return;

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$drawer.prepareTransition();

    this.nodes.$parent.removeClass(
      this.config.dirOpenClass + ' ' + this.config.openClass
    );
    $('html').removeClass(this.config.openClass);

    this.drawerIsOpen = false;

    // Remove focus on drawer
    this.removeTrapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    this.nodes.$page.off('.drawer');
    this.nodes.$parent.off('.drawer');
  };

  /**
  * Traps the focus in a particular container
  *
  * @param {object} options - Options to be used
  * @param {jQuery} options.$container - Container to trap focus within
  * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
  * @param {string} options.namespace - Namespace used for new focus event handler
  */
  Drawer.prototype.trapFocus = function(options) {
    var eventName = options.namespace
    ? 'focusin.' + options.namespace
    : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (
        options.$container[0] !== evt.target &&
        !options.$container.has(evt.target).length
      ) {
        options.$container.focus();
      }
    });
  };

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  Drawer.prototype.removeTrapFocus = function(options) {
    var eventName = options.namespace
    ? 'focusin.' + options.namespace
    : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  };

  return Drawer;
})();


/* ================ MODULES ================ */

theme.Header = (function() {
  var selectors = {
    body: 'body',
    navigation: '#AccessibleNav',
    siteNavHasDropdown: '.site-nav--has-dropdown',
    siteNavChildLinks: '.site-nav__child-link',
    siteNavActiveDropdown: '.site-nav--active-dropdown',
    siteNavLinkMain: '.site-nav__link--main',
    siteNavChildLink: '.site-nav__link--last',
    announcementBar: 	'.announcement-bar',
    fullHeader: '#shopify-section-header',
    mainContent: 	'.main-content',
    pageHero: '.collection-hero',
    productPage: '.template-product'
  };

  var config = {
    activeClass: 'site-nav--active-dropdown',
    childLinkClass: 'site-nav__child-link'
  };

  var cache = {};
  $('nav.BenefitNav.desktop ul').slick({
    draggable: true,
    accessibility: false,
    variableWidth: false,
    slidesToShow: 4,
    slidesToScroll: 4,
    arrows:true,
    infinite:false,
    centerMode: false, 
    initialSlide: 0
  });
  var $headerHeight = $(selectors.fullHeader).outerHeight();

  function init() {
    cacheSelectors();

    cache.$parents.on('click.siteNav', function() {
      var $el = $(this);

      $el.hasClass(config.activeClass) ? hideDropdown($el) : showDropdown($el);
    });
    setHeaderHeight();
    if ($('body').hasClass('currencies-enabled')) {
      theme.currencySwitcher.init();
    }
    //autoCompleteSearch();

    //Changed this to liquid in site-nav.liquid
    //$('.site-nav__link--button:contains("Buy Now")').addClass('buy-now--btn');

    // check when we're leaving a dropdown and close the active dropdown
    $(selectors.siteNavChildLink).on('focusout.siteNav', function() {
      setTimeout(function() {
        if (
          $(document.activeElement).hasClass(config.childLinkClass) ||
          !cache.$activeDropdown.length
        ) {
          return;
        }

        hideDropdown(cache.$activeDropdown);
      });
    });

    // close dropdowns when on top level nav
    cache.$topLevel.on('focus.siteNav', function() {
      if (cache.$activeDropdown.length) {
        hideDropdown(cache.$activeDropdown);
      }
    });

    cache.$subMenuLinks.on('click.siteNav', function(evt) {
      // Prevent click on body from firing instead of link
      evt.stopImmediatePropagation();
    });
  }
  function setHeaderHeight() {

    // $(selectors.announcementBar).css('height',$(selectors.announcementBar).outerHeight()).attr('data-original-height',$(selectors.announcementBar).outerHeight());
    $(selectors.mainContent).css('padding-top',$headerHeight);
    // if($('body').hasClass('template-index') && theme.isMobile() == false) {
    //    $(selectors.mainContent).css('margin-top','55px');
    // }
    // if($(selectors.pageHero).length <= 0 && theme.isMobile() == false && $(selectors.productPage).length <=0  ) {
    //   $(selectors.mainContent).css('margin-top','55px');
    // }
  }

  $(window).on('resize', function(evt) {
    setHeaderHeight();
  });

  function cacheSelectors() {
    cache = {
      $nav: $(selectors.navigation),
      $topLevel: $(selectors.siteNavLinkMain),
      $parents: $(selectors.navigation).find(selectors.siteNavHasDropdown),
      $subMenuLinks: $(selectors.siteNavChildLinks),
      $activeDropdown: $(selectors.siteNavActiveDropdown)
    };
  }

  function showDropdown($el) {
    $el.addClass(config.activeClass);

    // close open dropdowns
    if (cache.$activeDropdown.length) {
      hideDropdown(cache.$activeDropdown);
    }

    cache.$activeDropdown = $el;

    // set expanded on open dropdown
    $el.find(selectors.siteNavLinkMain).attr('aria-expanded', 'true');

    setTimeout(function() {
      $(window).on('keyup.siteNav', function(evt) {
        if (evt.keyCode === 27) {
          hideDropdown($el);
        }
      });

      $(selectors.body).on('click.siteNav', function() {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown($el) {
    // remove aria on open dropdown
    $el.find(selectors.siteNavLinkMain).attr('aria-expanded', 'false');
    $el.removeClass(config.activeClass);

    // reset active dropdown
    cache.$activeDropdown = $(selectors.siteNavActiveDropdown);

    $(selectors.body).off('click.siteNav');
    $(window).off('keyup.siteNav');
  }

  function unload() {
    $(window).off('.siteNav');
    cache.$parents.off('.siteNav');
    cache.$subMenuLinks.off('.siteNav');
    cache.$topLevel.off('.siteNav');
    $(selectors.siteNavChildLink).off('.siteNav');
    $(selectors.body).off('.siteNav');
  }

  function autoCompleteSearch() {
    // Current Ajax request.
    var currentAjaxRequest = null;
    // Grabbing all search forms on the page, and adding a .search-results list to each.
    var searchForms = $('form[action="/search"]').each(function() {
      // Grabbing text input.
      var input = $(this).find('input[name="q"]');
      // Adding a list for showing search results.
      //var offSet = $('#topsearch').position().top + $('#topsearch').innerHeight() + input.position().top + input.innerHeight();
      $('<ul class="search-results"></ul>').css( { 'position': 'absolute', 'left': '0px', 'top': '100%' } ).appendTo($(this));
      // Listening to keyup and change on the text field within these search forms.
      input.attr('autocomplete', 'off').bind('keyup change', function() {
        // What's the search term?
        var term = $(this).val();
        //console.log(term);
        // What's the search form?
        var form = $(this).closest('form');
        // What's the search URL?
        var searchURL = '/search?type=product&q=' + term;
        // What's the search results list?
        var resultsList = form.find('.search-results');
        // If that's a new term and it contains at least 3 characters.
        if (term.length > 3 && term != $(this).attr('data-old-term')) {
          // Saving old query.
          $(this).attr('data-old-term', term);
          // Killing any Ajax request that's currently being processed.
          if (currentAjaxRequest != null) currentAjaxRequest.abort();
          // Pulling results.
          currentAjaxRequest = $.getJSON(searchURL + '&view=json', function(data) {
            // Reset results.
            resultsList.empty();
            // If we have no results.
            if(data.results_count == 0) {
              // resultsList.html('<li><span class="title">No results.</span></li>');
              // resultsList.fadeIn(200);
              resultsList.hide();
            } else {
              // If we have results.
              $.each(data.items, function(index, item) {
                var link = $('<a></a>').attr('href', item.url);
                link.append('<span class="thumbnail"><img src="' + item.featured_image + '" /></span>');
                link.append('<span class="title">' + item.title + '</span>');
                link.wrap('<li></li>');
                resultsList.append(link.parent());
              });
              // The Ajax request will return at the most 10 results.
              // If there are more than 10, let's link to the search results page.
              if(data.results_count > 10) {
                resultsList.append('<li><span class="title"><a href="' + searchURL + '">See all results (' + data.results_count + ')</a></span></li>');
              }
              resultsList.fadeIn(200);
            }        
          });
        }
      });
    });
    // Clicking outside makes the results disappear.
    $('body').bind('click', function(){
      $('.search-results').hide();
    });
  }



  return {
    init: init,
    unload: unload
  };
})();



theme.Footer = (function() {
  var selectors = {
    body: 'body',
    mainContent: '.main-content',
    footer: '#shopify-section-footer',
    scrollToTop: '#scroll-to-top',
    pageContainer: '#PageContainer'
  };

  var config = {
    parallaxClass: 'site-footer--parallax"'
  };

  var $footerHeight = $(selectors.footer).outerHeight();
  var $footerPadding = parseInt(($(selectors.footer).css('margin-top') || '0').replace('px',''));

  function init() {
    //console.log('init Footer');
    //$(selectors.pageContainer).css('margin-bottom',$footerHeight+$footerPadding+'px');
    if(theme.isMobile()) {
      $('.site-footer h4').on('click',function(e) {
        e.preventDefault();
        $(this).toggleClass('active').next().slideToggle();
      });
    }
    $(selectors.scrollToTop).on('click',function(e) {
      e.preventDefault();
      $('html,body').animate({scrollTop:0}, 500);
    });



  }

  return {
    init: init
  };
})();




theme.drawersInit = function () {
  // Add required classes to HTML
  $('#PageContainer').addClass('drawer-page-content');
  $('.js-drawer-open-right').attr('aria-controls', 'CartDrawer').attr('aria-expanded', 'false');
  $('.js-drawer-open-left').attr('aria-controls', 'NavDrawer').attr('aria-expanded', 'false');
  $('.js-drawer-open-top').attr('aria-controls', 'SearchDrawer').attr('aria-expanded', 'false');

  theme.LeftDrawer = new theme.Drawers('NavDrawer', 'left', {'beforeDrawerOpen': theme.closeCart});
  theme.RightDrawer = new theme.Drawers('CartDrawer', 'right', {'beforeDrawerOpen': theme.closeNav});
  theme.SearchDrawer = new theme.Drawers('SearchDrawer', 'top', {'beforeDrawerOpen': theme.searchFocus});

};

theme.closeNav = function() {
  theme.initCart();
  theme.LeftDrawer.close();

};
theme.closeCart = function() {
  theme.RightDrawer.close();
  theme.initMobileNav();
  $('.drawer-nav__has-sublist').removeClass('drawer-nav--expanded');
  //$('.drawer-nav__sublist').hide();
};

theme.initCart = function () {
  //Anything to set up?
};

theme.initMobileNav = function() {
  //Anything to set up?
};

/*theme.searchFocus = function () {
  theme.LeftDrawer.close();
  theme.RightDrawer.close();
  //theme.cache.$searchInput.focus();
  // set selection range hack for iOS
  //theme.cache.$searchInput[0].setSelectionRange(0, theme.cache.$searchInput[0].value.length);
};

theme.searchSubmit = function () {
  theme.cache.$searchSubmit.on('click', function(evt) {
    if (theme.cache.$searchInput.val().length == 0) {
      evt.preventDefault();
      theme.cache.$searchInput.focus();
    }
  });
};
*/

theme.Search = (function() {
  var selectors = {
    search: '.search',
    searchSubmit: '.search__submit',
    searchInput: '.search__input',

    siteHeader: '.site-header',
    siteHeaderSearchToggle: '.site-header__search-toggle',
    siteHeaderSearch: '.site-header__search',

    searchDrawer: '.search-bar',
    searchDrawerInput: '.search-bar__input',

    searchHeader: '.search-header',
    searchHeaderInput: '.search-header__input',
    searchHeaderSubmit: '.search-header__submit',

    mobileNavWrapper: '.mobile-nav-wrapper'
  };

  var classes = {
    focus: 'search--focus',
    mobileNavIsOpen: 'js-menu--is-open'
  };

  function init() {
    if (!$(selectors.siteHeader).length) {
      return;
    }

    initDrawer();
    searchSubmit();

    $(selectors.searchHeaderInput)
    .add(selectors.searchHeaderSubmit)
    //       .on('focus blur', function() {
    //         $(selectors.searchHeader).toggleClass(classes.focus);
    //       });

    .on('click', function() {
      //$(selectors.searchHeader).toggleClass(classes.focus);
      if($(this).parents('.search-header').hasClass('search--focus')){
        $(this).parents('.search-header').removeClass('search--focus');
      }
      else{
        $(this).parents('.search-header').addClass('search--focus');
      }
    });


    $(selectors.siteHeaderSearchToggle).on('click', function() {
      var searchHeight = $('#shopify-section-header').outerHeight();
      var searchOffset = $(selectors.siteHeader).offset().top - searchHeight;

      $(selectors.searchDrawer).css({
        height: searchHeight + 'px'
      });
    });
    $(selectors.searchHeaderInput).hover(function() {
      //console.log('boom');
      $(selectors.searchHeader + '.has-text i').addClass('show');
    },function() {
      //console.log('remove z boom');
      $(selectors.searchHeader + '.has-text i').removeClass('show');
    });
  }

  function initDrawer() {
    // Add required classes to HTML
    $('#PageContainer').addClass('drawer-page-content');
    $('.js-drawer-open-top')
    .attr('aria-controls', 'SearchDrawer')
    .attr('aria-expanded', 'false')
    .attr('aria-haspopup', 'dialog');

    theme.SearchDrawer = new theme.Drawers('SearchDrawer', 'top', {
      onDrawerOpen: searchDrawerFocus,
      onDrawerClose: searchDrawerFocusClose
    });

  }

  function searchDrawerFocus() {
    searchFocus($(selectors.searchDrawerInput));

    if ($(selectors.mobileNavWrapper).hasClass(classes.mobileNavIsOpen)) {
      //theme.MobileNav.closeMobileNav();
    }
  }

  function searchFocus($el) {
    $el.focus();
    // set selection range hack for iOS
    $el[0].setSelectionRange(0, $el[0].value.length);
  }

  function searchDrawerFocusClose() {
    $(selectors.siteHeaderSearchToggle).focus();
  }

  function searchSubmit() {
    $(selectors.searchSubmit).on('click', function(evt) {
      var $el = $(evt.target);
      var $input = $el.parents(selectors.search).find(selectors.searchInput);
      if ($input.val().length === 0) {
        evt.preventDefault();
        searchFocus($input);
      }
    });
  }

  return {
    init: init
  };
})();

/*
(function() {
  var selectors = {
    backButton: '.return-link'
  };

  var $backButton = $(selectors.backButton);

  if (!document.referrer || !$backButton.length || !window.history.length) {
    return;
  }

  $backButton.one('click', function(evt) {
    evt.preventDefault();

    var referrerDomain = urlDomain(document.referrer);
    var shopDomain = urlDomain(window.location.href);

    if (shopDomain === referrerDomain) {
      history.back();
    }

    return false;
  });

  function urlDomain(url) {
    var anchor = document.createElement('a');
    anchor.ref = url;

    return anchor.hostname;
  }
})();
*/


theme.FeaturedCollectionSlider = (function() {

  $('.featured-collection').slick({
    infinite: true,
    prevArrow: prevArrowSVG,
    nextArrow: nextArrowSVG,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  });

  function featuredSlider(el) {

  }
  return featuredSlider;
})();


theme.MediaSlider = (function() {

  var parentSlider =  $('.media-slider__parent'),
      navSlider = $('.media-slider__nav'),
      killit = false;

  parentSlider.slick({
    autoplay: true,
    infinite: true,
    prevArrow: prevArrowSVG,
    nextArrow: nextArrowSVG
  });

  parentSlider.on('afterChange', function(event, slick, currentSlide, nextSlide){
    var elSlide = $(slick.$slides[currentSlide]);
    var dataIndex = elSlide.data('slick-index');
    killit = false;

    $('.media-slider__item').each(function(){
      if($(this).data('thumb') == dataIndex + 1) {
        $(this).addClass('active');
      }else {
        $(this).removeClass('active');
      }
    });
  });
  parentSlider.on('beforeChange', function(){
    killit = true;
  });
  // $(navSlider).slick({
  //   slidesPerRow: 3,
  //   rows: 2
  // });
  // $(parentSlider).slick({
  //   autoplay: true,
  //   asNavFor: navSlider
  // });

  navSlider.find('li').on("click", function(e){
    if( !killit ) {
      e.stopPropagation();
      var idx = $(this).data("thumb");
      parentSlider.slick("goTo", idx-1);
    }
  });

  // $(navSlider)
  // .on("beforeChange", function() {
  //     killit = true;
  // }).on("afterChange", function() {
  //     killit = false;
  // });


  function MediaSlider(el) {

  }
  return MediaSlider;
})();


theme.Slideshow = (function() {
  this.$slideshow = null;
  var classes = {
    wrapper: 'slideshow-wrapper',
    slideshow: 'slideshow',
    currentSlide: 'slick-current',
    video: 'slideshow__video',
    videoBackground: 'slideshow__video--background',
    closeVideoBtn: 'slideshow__video-control--close',
    pauseButton: 'slideshow__pause',
    isPaused: 'is-paused'
  };

  function slideshow(el) {
    this.$slideshow = $(el);
    this.$wrapper = this.$slideshow.closest('.' + classes.wrapper);
    this.$pause = this.$wrapper.find('.' + classes.pauseButton);

    this.settings = {
      accessibility: true,
      arrows: true,
      dots: true,
      fade: false,
      draggable: true,
      adaptiveHeight: true,
      touchThreshold: 20,
      autoplay: this.$slideshow.data('autoplay'),
      autoplaySpeed: this.$slideshow.data('speed'),
      prevArrow: '<button type="button" class="slick-prev">'+prevArrowSVG+'</button>',
      nextArrow: '<button type="button" class="slick-next">'+nextArrowSVG+'</button>'
    };

    this.$slideshow.on('beforeChange', beforeChange.bind(this));
    this.$slideshow.on('init', slideshowA11y.bind(this));
    this.$slideshow.slick(this.settings);

    this.$pause.on('click', this.togglePause.bind(this));
  }

  function slideshowA11y(event, obj) {
    var $slider = obj.$slider;
    var $list = obj.$list;
    var $wrapper = this.$wrapper;
    var autoplay = this.settings.autoplay;

    // Remove default Slick aria-live attr until slider is focused
    $list.removeAttr('aria-live');

    // When an element in the slider is focused
    // pause slideshow and set aria-live.
    $wrapper.on('focusin', function(evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.attr('aria-live', 'polite');

      if (autoplay) {
        $slider.slick('slickPause');
      }
    });

    // Resume autoplay
    $wrapper.on('focusout', function(evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.removeAttr('aria-live');

      if (autoplay) {
        // Manual check if the focused element was the video close button
        // to ensure autoplay does not resume when focus goes inside YouTube iframe
        if ($(evt.target).hasClass(classes.closeVideoBtn)) {
          return;
        }

        $slider.slick('slickPlay');
      }
    });

    // Add arrow key support when focused
    if (obj.$dots) {
      obj.$dots.on('keydown', function(evt) {
        if (evt.which === 37) {
          $slider.slick('slickPrev');
        }

        if (evt.which === 39) {
          $slider.slick('slickNext');
        }

        // Update focus on newly selected tab
        if (evt.which === 37 || evt.which === 39) {
          obj.$dots.find('.slick-active button').focus();
        }
      });
    }
  }

  function beforeChange(event, slick, currentSlide, nextSlide) {
    var $slider = slick.$slider;
    var $currentSlide = $slider.find('.' + classes.currentSlide);
    var $nextSlide = $slider.find(
      '.slideshow__slide[data-slick-index="' + nextSlide + '"]'
    );

    if (isVideoInSlide($currentSlide)) {
      var $currentVideo = $currentSlide.find('.' + classes.video);
      var currentVideoId = $currentVideo.attr('id');
      theme.SlideshowVideo.pauseVideo(currentVideoId);
      $currentVideo.attr('tabindex', '-1');
    }

    if (isVideoInSlide($nextSlide)) {
      var $video = $nextSlide.find('.' + classes.video);
      var videoId = $video.attr('id');
      var isBackground = $video.hasClass(classes.videoBackground);
      if (isBackground) {
        theme.SlideshowVideo.playVideo(videoId);
      } else {
        $video.attr('tabindex', '0');
      }
    }
  }

  function isVideoInSlide($slide) {
    return $slide.find('.' + classes.video).length;
  }

  slideshow.prototype.togglePause = function() {
    var slideshowSelector = getSlideshowId(this.$pause);
    if (this.$pause.hasClass(classes.isPaused)) {
      this.$pause.removeClass(classes.isPaused);
      $(slideshowSelector).slick('slickPlay');
    } else {
      this.$pause.addClass(classes.isPaused);
      $(slideshowSelector).slick('slickPause');
    }
  };

  function getSlideshowId($el) {
    return '#Slideshow-' + $el.data('id');
  }

  return slideshow;
})();

// Youtube API callback
// eslint-disable-next-line no-unused-vars
function onYouTubeIframeAPIReady() {
  theme.SlideshowVideo.loadVideos();
}

theme.SlideshowVideo = (function() {
  var autoplayCheckComplete = false;
  var autoplayAvailable = false;
  var playOnClickChecked = false;
  var playOnClick = false;
  var youtubeLoaded = false;
  var videos = {};
  var videoPlayers = [];
  var videoOptions = {
    ratio: 16 / 9,
    playerVars: {
      // eslint-disable-next-line camelcase
      iv_load_policy: 3,
      modestbranding: 1,
      autoplay: 0,
      controls: 0,
      showinfo: 0,
      wmode: 'opaque',
      branding: 0,
      autohide: 0,
      rel: 0
    },
    events: {
      onReady: onPlayerReady,
      onStateChange: onPlayerChange
    }
  };
  var classes = {
    playing: 'video-is-playing',
    paused: 'video-is-paused',
    loading: 'video-is-loading',
    loaded: 'video-is-loaded',
    slideshowWrapper: 'slideshow-wrapper',
    slide: 'slideshow__slide',
    slideBackgroundVideo: 'slideshow__slide--background-video',
    slideDots: 'slick-dots',
    videoChrome: 'slideshow__video--chrome',
    videoBackground: 'slideshow__video--background',
    playVideoBtn: 'slideshow__video-control--play',
    closeVideoBtn: 'slideshow__video-control--close',
    currentSlide: 'slick-current',
    slickClone: 'slick-cloned',
    supportsAutoplay: 'autoplay',
    supportsNoAutoplay: 'no-autoplay'
  };

  /**
   * Public functions
   */
  function init($video) {
    if (!$video.length) {
      return;
    }

    videos[$video.attr('id')] = {
      id: $video.attr('id'),
      videoId: $video.data('id'),
      type: $video.data('type'),
      status: $video.data('type') === 'chrome' ? 'closed' : 'background', // closed, open, background
      videoSelector: $video.attr('id'),
      $parentSlide: $video.closest('.' + classes.slide),
      $parentSlideshowWrapper: $video.closest('.' + classes.slideshowWrapper),
      controls: $video.data('type') === 'background' ? 0 : 1,
      slideshow: $video.data('slideshow')
    };

    if (!youtubeLoaded) {
      // This code loads the IFrame Player API code asynchronously.
      var tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  }

  function customPlayVideo(playerId) {
    // Do not autoplay just because the slideshow asked you to.
    // If the slideshow asks to play a video, make sure
    // we have done the playOnClick check first
    if (!playOnClickChecked && !playOnClick) {
      return;
    }

    if (playerId && typeof videoPlayers[playerId].playVideo === 'function') {
      privatePlayVideo(playerId);
    }
  }

  function pauseVideo(playerId) {
    if (
      videoPlayers[playerId] &&
      typeof videoPlayers[playerId].pauseVideo === 'function'
    ) {
      videoPlayers[playerId].pauseVideo();
    }
  }

  function loadVideos() {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var args = $.extend({}, videoOptions, videos[key]);
        args.playerVars.controls = args.controls;
        videoPlayers[key] = new YT.Player(key, args);
      }
    }

    initEvents();
    youtubeLoaded = true;
  }

  function loadVideo(key) {
    if (!youtubeLoaded) {
      return;
    }
    var args = $.extend({}, videoOptions, videos[key]);
    args.playerVars.controls = args.controls;
    videoPlayers[key] = new YT.Player(key, args);

    initEvents();
  }

  /**
   * Private functions
   */

  function privatePlayVideo(id, clicked) {
    var videoData = videos[id];
    var player = videoPlayers[id];
    var $slide = videos[id].$parentSlide;

    if (playOnClick) {
      // playOnClick means we are probably on mobile (no autoplay).
      // setAsPlaying will show the iframe, requiring another click
      // to play the video.
      setAsPlaying(videoData);
    } else if (clicked || (autoplayCheckComplete && autoplayAvailable)) {
      // Play if autoplay is available or clicked to play
      $slide.removeClass(classes.loading);
      setAsPlaying(videoData);
      player.playVideo();
      return;
    }

    // Check for autoplay if not already done
    if (!autoplayCheckComplete) {
      autoplayCheckFunction(player, $slide);
    }
  }

  function setAutoplaySupport(supported) {
    var supportClass = supported
    ? classes.supportsAutoplay
    : classes.supportsNoAutoplay;
    $(document.documentElement).addClass(supportClass);

    if (!supported) {
      playOnClick = true;
    }

    autoplayCheckComplete = true;
  }

  function autoplayCheckFunction(player, $slide) {
    // attempt to play video
    player.playVideo();

    autoplayTest(player)
    .then(function() {
      setAutoplaySupport(true);
    })
    .fail(function() {
      // No autoplay available (or took too long to start playing).
      // Show fallback image. Stop video for safety.
      setAutoplaySupport(false);
      player.stopVideo();
    })
    .always(function() {
      autoplayCheckComplete = true;
      $slide.removeClass(classes.loading);
    });
  }

  function autoplayTest(player) {
    var deferred = $.Deferred();
    var wait;
    var timeout;

    wait = setInterval(function() {
      if (player.getCurrentTime() <= 0) {
        return;
      }

      autoplayAvailable = true;
      clearInterval(wait);
      clearTimeout(timeout);
      deferred.resolve();
    }, 500);

    timeout = setTimeout(function() {
      clearInterval(wait);
      deferred.reject();
    }, 4000); // subjective. test up to 8 times over 4 seconds

    return deferred;
  }

  function playOnClickCheck() {
    // Bail early for a few instances:
    // - small screen
    // - device sniff mobile browser

    if (playOnClickChecked) {
      return;
    }

    if ($(window).width() < 750) {
      playOnClick = true;
    } else if (window.mobileCheck()) {
      playOnClick = true;
    }

    if (playOnClick) {
      // No need to also do the autoplay check
      setAutoplaySupport(false);
    }

    playOnClickChecked = true;
  }

  // The API will call this function when each video player is ready
  function onPlayerReady(evt) {
    evt.target.setPlaybackQuality('hd1080');
    var videoData = getVideoOptions(evt);

    playOnClickCheck();

    // Prevent tabbing through YouTube player controls until visible
    $('#' + videoData.id).attr('tabindex', '-1');

    sizeBackgroundVideos();

    // Customize based on options from the video ID
    switch (videoData.type) {
      case 'background-chrome':
      case 'background':
        evt.target.mute();
        // Only play the video if it is in the active slide
        if (videoData.$parentSlide.hasClass(classes.currentSlide)) {
          privatePlayVideo(videoData.id);
        }
        break;
    }

    videoData.$parentSlide.addClass(classes.loaded);
  }

  function onPlayerChange(evt) {
    var videoData = getVideoOptions(evt);

    switch (evt.data) {
      case 0: // ended
        setAsFinished(videoData);
        break;
      case 1: // playing
        setAsPlaying(videoData);
        break;
      case 2: // paused
        setAsPaused(videoData);
        break;
    }
  }

  function setAsFinished(videoData) {
    switch (videoData.type) {
      case 'background':
        videoPlayers[videoData.id].seekTo(0);
        break;
      case 'background-chrome':
        videoPlayers[videoData.id].seekTo(0);
        closeVideo(videoData.id);
        break;
      case 'chrome':
        closeVideo(videoData.id);
        break;
    }
  }

  function setAsPlaying(videoData) {
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;

    $slide.removeClass(classes.loading);

    // Do not change element visibility if it is a background video
    if (videoData.status === 'background') {
      return;
    }

    $('#' + videoData.id).attr('tabindex', '0');

    switch (videoData.type) {
      case 'chrome':
      case 'background-chrome':
        $slideshow.removeClass(classes.paused).addClass(classes.playing);
        $slide.removeClass(classes.paused).addClass(classes.playing);
        break;
    }

    // Update focus to the close button so we stay within the slide
    $slide.find('.' + classes.closeVideoBtn).focus();
  }

  function setAsPaused(videoData) {
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;

    if (videoData.type === 'background-chrome') {
      closeVideo(videoData.id);
      return;
    }

    // YT's events fire after our click event. This status flag ensures
    // we don't interact with a closed or background video.
    if (videoData.status !== 'closed' && videoData.type !== 'background') {
      $slideshow.addClass(classes.paused);
      $slide.addClass(classes.paused);
    }

    if (videoData.type === 'chrome' && videoData.status === 'closed') {
      $slideshow.removeClass(classes.paused);
      $slide.removeClass(classes.paused);
    }

    $slideshow.removeClass(classes.playing);
    $slide.removeClass(classes.playing);
  }

  function closeVideo(playerId) {
    var videoData = videos[playerId];
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;
    var classesToRemove = [classes.pause, classes.playing].join(' ');

    $('#' + videoData.id).attr('tabindex', '-1');

    videoData.status = 'closed';

    switch (videoData.type) {
      case 'background-chrome':
        videoPlayers[playerId].mute();
        setBackgroundVideo(playerId);
        break;
      case 'chrome':
        videoPlayers[playerId].stopVideo();
        setAsPaused(videoData); // in case the video is already paused
        break;
    }

    $slideshow.removeClass(classesToRemove);
    $slide.removeClass(classesToRemove);
  }

  function getVideoOptions(evt) {
    return videos[evt.target.h.id];
  }

  function startVideoOnClick(playerId) {
    var videoData = videos[playerId];
    // add loading class to slide
    videoData.$parentSlide.addClass(classes.loading);

    videoData.status = 'open';

    switch (videoData.type) {
      case 'background-chrome':
        unsetBackgroundVideo(playerId, videoData);
        videoPlayers[playerId].unMute();
        privatePlayVideo(playerId, true);
        break;
      case 'chrome':
        privatePlayVideo(playerId, true);
        break;
    }

    // esc to close video player
    $(document).on('keydown.videoPlayer', function(evt) {
      if (evt.keyCode === 27) {
        closeVideo(playerId);
      }
    });
  }

  function sizeBackgroundVideos() {
    $('.' + classes.videoBackground).each(function(index, el) {
      sizeBackgroundVideo($(el));
    });
  }

  function sizeBackgroundVideo($player) {
    var $slide = $player.closest('.' + classes.slide);
    // Ignore cloned slides
    if ($slide.hasClass(classes.slickClone)) {
      return;
    }
    var slideWidth = $slide.width();
    var playerWidth = $player.width();
    var playerHeight = $player.height();

    // when screen aspect ratio differs from video, video must center and underlay one dimension
    if (slideWidth / videoOptions.ratio < playerHeight) {
      playerWidth = Math.ceil(playerHeight * videoOptions.ratio); // get new player width
      $player
      .width(playerWidth)
      .height(playerHeight)
      .css({
        left: (slideWidth - playerWidth) / 2,
        top: 0
      }); // player width is greater, offset left; reset top
    } else {
      // new video width < window width (gap to right)
      playerHeight = Math.ceil(slideWidth / videoOptions.ratio); // get new player height
      $player
      .width(slideWidth)
      .height(playerHeight)
      .css({
        left: 0,
        top: (playerHeight - playerHeight) / 2
      }); // player height is greater, offset top; reset left
    }

    $player.prepareTransition().addClass(classes.loaded);
  }

  function unsetBackgroundVideo(playerId) {
    // Switch the background-chrome to a chrome-only player once played
    $('#' + playerId)
    .removeAttr('style')
    .removeClass(classes.videoBackground)
    .addClass(classes.videoChrome);

    videos[playerId].$parentSlideshowWrapper
    .removeClass(classes.slideBackgroundVideo)
    .addClass(classes.playing);

    videos[playerId].$parentSlide
    .removeClass(classes.slideBackgroundVideo)
    .addClass(classes.playing);

    videos[playerId].status = 'open';
  }

  function setBackgroundVideo(playerId) {
    // Switch back to background-chrome when closed
    var $player = $('#' + playerId)
    .addClass(classes.videoBackground)
    .removeClass(classes.videoChrome);

    videos[playerId].$parentSlide.addClass(classes.slideBackgroundVideo);

    videos[playerId].status = 'background';
    sizeBackgroundVideo($player);
  }

  function initEvents() {
    $(document).on('click.videoPlayer', '.' + classes.playVideoBtn, function(
                   evt
    ) {
      var playerId = $(evt.currentTarget).data('controls');
      startVideoOnClick(playerId);
    });

    $(document).on('click.videoPlayer', '.' + classes.closeVideoBtn, function(
                   evt
    ) {
      var playerId = $(evt.currentTarget).data('controls');
      closeVideo(playerId);
    });

    // Listen to resize to keep a background-size:cover-like layout
    $(window).on(
      'resize.videoPlayer',
      $.debounce(250, function() {
        if (youtubeLoaded) {
          sizeBackgroundVideos();
        }
      })
    );
  }

  function removeEvents() {
    $(document).off('.videoPlayer');
    $(window).off('.videoPlayer');
  }

  return {
    init: init,
    loadVideos: loadVideos,
    loadVideo: loadVideo,
    playVideo: customPlayVideo,
    pauseVideo: pauseVideo,
    removeEvents: removeEvents
  };
})();


/* ================ TEMPLATES ================ */
(function() {
  var $filterBy = $('#BlogTagFilter');

  if (!$filterBy.length) {
    return;
  }

  $filterBy.on('change', function() {
    location.href = $(this).val();
  });
})();



theme.customerTemplates = (function() {
  function initEventListeners() {
    // Show reset password form
    $('#RecoverPassword').on('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });

    // Hide reset password form
    $('#HideRecoverPasswordLink').on('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });
  }

  /**
   *
   *  Show/Hide recover password form
   *
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *
   *  Show reset password success message
   *
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }

  /**
   *
   *  Show/hide customer address forms
   *
   */
  function customerAddressForm() {
    var $newAddressForm = $('#AddressNewForm');

    if (!$newAddressForm.length) {
      return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(
        'AddressCountryNew',
        'AddressProvinceNew',
        {
          hideElement: 'AddressProvinceContainerNew'
        }
      );
    }

    // Initialize each edit form's country/province selector
    $('.address-country-option').each(function() {
      var formId = $(this).data('form-id');
      var countrySelector = 'AddressCountry_' + formId;
      var provinceSelector = 'AddressProvince_' + formId;
      var containerSelector = 'AddressProvinceContainer_' + formId;

      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector
      });
    });

    // Toggle new/edit address forms
    $('.address-new-toggle').on('click', function() {
      $newAddressForm.toggleClass('hide');
    });

    $('.address-edit-toggle').on('click', function() {
      var formId = $(this).data('form-id');
      $('#EditAddress_' + formId).toggleClass('hide');
    });

    $('.address-delete').on('click', function() {
      var $el = $(this);
      var formId = $el.data('form-id');
      var confirmMessage = $el.data('confirm-message');

      // eslint-disable-next-line no-alert
      if (
        confirm(
          confirmMessage || 'Are you sure you wish to delete this address?'
        )
      ) {
        Shopify.postLink('/account/addresses/' + formId, {
          parameters: { _method: 'delete' }
        });
      }
    });
  }

  /**
   *
   *  Check URL for reset password hash
   *
   */
  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  return {
    init: function() {
      checkUrlHash();
      initEventListeners();
      resetPasswordSuccess();
      customerAddressForm();
    }
  };
})();


/*================ SECTIONS ================*/


theme.Cart = (function() {

  if(Cookies.get('last-collection') != undefined) {
    $('.cart__continue-btn').attr('href',Cookies.get('last-collection'));
  }

  var selectors = {
    edit: '.js-edit-toggle',
    remove: '.cart__remove',
    update: '.cart__update',
    size: '.single-option-selector'
  };
  var config = {
    showClass: 'cart__update--show',
    showEditClass: 'cart__edit--active',
    cartNoCookies: 'cart--no-cookies'
  };




  /*
  $(document).on('change',selectors.size,function(e) {
    e.preventDefault();
    $('.cart-preloader').fadeIn();

    var $evtTarget = $(e.target);
    var $row = $evtTarget.closest('.cart__row');
    var $line = parseInt($row.data('line'));
    var $qty = $row.find('.cart__qty-input').val();
    jQuery.post('/cart/change.js', { quantity: $qty, line: $line })
    .done(function() {
      //theme.updateCartFromForm('cart-page__form');
    });
  });
  */

  /*
  $(document).on('change','.cart-size-change',function(e) {
    e.preventDefault();
    var removeID = $(this).data('variant-id');
    var addID = $(this).val();
    var myQty = parseInt($('#qty-'+removeID).val());
    CartJS.removeItemById(removeID);
    $('#cart-cover').fadeIn();
    CartJS.addItem(addID, myQty, {}, {
      "success": function(data,textStatus,jqXHR) {
        //UpdateCartHeader();
        UpdateCart();
      }
    });
  });
  */


  $(document).on('keyup','.cart__qty-input',function(e) {
    e.preventDefault();
    $('.cart-preloader').fadeIn();
    setTimeout(function(){
      $('.cart__update').trigger('click');
    }, 500);
  });

  function Cart(container) {
    this.$container = $(container);
    this.$edit = $(selectors.edit, this.$container);
    this.$remove = $(selectors.remove, this.$container);

    if (!this.cookiesEnabled()) {
      this.$container.addClass(config.cartNoCookies);
    }
    $(document).on('click',this.$edit,this._onEditClick.bind(this));
    //this.$edit.on('click', this._onEditClick.bind(this));
    //$(document).on('click',this.$remove,this._onRemoveClick.bind(this));

    $(document).on('click',selectors.remove,function(e) {
      e.preventDefault();
      $('.cart-preloader').fadeIn();

      var $evtTarget = $(e.target);
      var $row = $evtTarget.closest('.cart__row');
      //$row.fadeOut();
      $row.find('.cart__qty-input').val(0);
      $(selectors.update).trigger('click');
    });

    $(document).on('click',selectors.update,function(e) {
      e.preventDefault();
      theme.updateCartFromForm('cart-page__form');
    });

    //simpleParallax(100, $('.collection-hero'));
  }

  Cart.prototype = _.assignIn({}, Cart.prototype, {
    onUnload: function() {
      this.$edit.off('click', this._onEditClick);
    },
    _onRemoveClick: function(evt) {
      evt.preventDefault();
      var $evtTarget = $(evt.target);
      var $row = $evtTarget.closest('.cart__row');
      $row.fadeOut();
      //console.log($evtTarget.data('id'));

      theme.removeItem(parseInt($evtTarget.data('id')));
      //theme.updateCartPage();
    },
    _onEditClick: function(evt) {
      var $evtTarget = $(evt.target);
      var $updateLine = $('.' + $evtTarget.data('target'));

      $evtTarget.toggleClass(config.showEditClass);
      $updateLine.toggleClass(config.showClass);
    },

    cookiesEnabled: function() {
      var cookieEnabled = navigator.cookieEnabled;

      if (!cookieEnabled) {
        document.cookie = 'testcookie';
        cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
      }
      return cookieEnabled;
    }
  });

  return Cart;
})();





function getUrlParameter(name) {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  var results = regex.exec(location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};


theme.Filters = (function() {
  var constants = {
    SORT_BY: 'sort_by'
  };
  var selectors = {
    filterSelection: '#SortTags',
    sortSelection: '.collection-filters--sort-btn',
    sortLinks: '.collection-sort--link',
    defaultSort: '#DefaultSortBy'
  };

  function Filters(container) {
    var $container = (this.$container = $(container));

    //console.log('Collection');

    this.$filterSelect = $(selectors.filterSelection, $container);
    this.$sortSelect = $(selectors.sortSelection, $container);
    this.$sortSelectLinks = $(selectors.sortLinks, $container);
    this.$selects = $(selectors.filterSelection, $container).add(
      $(selectors.sortSelection, $container)
    );

    this.defaultSort = this._getDefaultSortValue();
    this._resizeSelect(this.$selects);
    this.$selects.removeClass('hidden');

    this.$filterSelect.on('change', this._onFilterChange.bind(this));
    this.$sortSelect.on('click', this._onSortClick.bind(this));
    this.$sortSelectLinks.on('click', this._onSortLinkClick.bind(this));

    theme.CollectionFilters();
  }

  Filters.prototype = _.assignIn({}, Filters.prototype, {
    _onSortClick: function(evt) {
      $(selectors.sortSelection).toggleClass('is-active');
      $('.collection-sort').toggleClass('is-active');
    },
    _onSortLinkClick: function(evt) {
      evt.preventDefault()
      //console.log($(evt.target));
      //$('.collection-sort').toggleClass('is-active');
      Shopify.queryParams = {};
      if (location.search.length) {
        for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
          aKeyValue = aCouples[i].split('=');
          if (aKeyValue.length > 1) {
            Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
          }
        }
      }
      Shopify.queryParams.sort_by = $(evt.target).attr("data-sortby");
      var location_search = $.param(Shopify.queryParams).replace(/\+/g, "%20"); 
      //location.search = $.param(Shopify.queryParams).replace(/\+/g, "%20");
      //console.log(window.location.pathname + location_search);
      var sorted_url = window.location.pathname + '?'+ location_search;
      $.ajax({
        url: sorted_url,
        type:'GET',
        beforeSend: function() {
          $('.collection-preloader').fadeIn();
        },
        success: function(data) {
          //           console.log('success!');
          $('#Collection .products').html($(data).find('#Collection .products').html());

          var title = $(data).filter('title').text();
          document.title = title;
          window.history.pushState({url: "" + sorted_url + ""}, title, sorted_url);
          $('.collection-preloader').fadeOut();
        }
      });

    },
    _onSortChange: function(evt) {

      var sort = this._sortValue();
      if (sort.length) {
        window.location.search = sort;
      } else {
        // clean up our url if the sort value is blank for default
        window.location.href = window.location.href.replace(
          window.location.search,
          ''
        );
      }
      this._resizeSelect($(evt.target));
    },

    _onFilterChange: function(evt) {
      var filter = this._getFilterValue();

      // remove the 'page' parameter to go to the first page of results
      var search = document.location.search.replace(/\?(page=\w+)?&?/, '');

      // only add the search parameters to the url if they exist
      search = search !== '' ? '?' + search : '';

      document.location.href = filter + search;
      this._resizeSelect($(evt.target));
    },

    _getFilterValue: function() {
      return this.$filterSelect.val();
    },

    _getSortValue: function() {
      return this.$sortSelect.val() || this.defaultSort;
    },

    _getDefaultSortValue: function() {
      return $(selectors.defaultSort, this.$container).val();
    },

    _sortValue: function() {
      var sort = this._getSortValue();
      var query = '';

      if (sort !== this.defaultSort) {
        query = constants.SORT_BY + '=' + sort;
      }

      return query;
    },

    _resizeSelect: function($selection) {
      $selection.each(function() {
        var $this = $(this);
        var arrowWidth = 10;
        // create test element
        var text = $this.find('option:selected').text();
        var $test = $('<span>').html(text);

        // add to body, get width, and get out
        $test.appendTo('body');
        var width = $test.width();
        $test.remove();

        // set select width
        $this.width(width + arrowWidth);
      });
    },

    onUnload: function() {
      this.$filterSelect.off('change', this._onFilterChange);
      this.$sortSelect.off('change', this._onSortChange);
    }
  });

  return Filters;
})();

theme.CollectionFilters = function() {

  if(theme.isMobile) {
    //$('.mobile-filters-inner').html($('.filters').html());
  }


  var initialCollectionHTML = false,
      initialCollectionTitle = false;
  
  initialCollectionHTML = $('#Collection').html();
  initialCollectionTitle = document.title;
  


  /* Collection Filtering  */
  var collFilters = $('.coll-filter'),
      checkedFilters = $('.coll-filter:checked'),
      collectionMain = $('#Collection'),
      collectionTitle = collectionMain.data('collection-title'),
      collectionHandle = collectionMain.data('collection-handle'),
      isFiltered = false,
      selectedColor = false,
      originalCache = collectionMain.html();



  function checkFilters() {
    isFiltered = false;
    var filterBy = '';
    collFilters.each(function() {
      var f = $(this);
      if(f.is(':checked')) {
        f.closest('.filter-group').find('.remove').show();
        isFiltered = true;
        if(filterBy == '') {
          filterBy = '.'+$(this).val();
        } else {
          filterBy = filterBy+'-'+$(this).val();
        }
      }
    });
    if(isFiltered) {
      //$('#Collection-Wrapper .grid__item').hide();
      //$('#Collection-Wrapper .product').filter(filterBy).parent().show();
      $('.remove-all').addClass('show');
      $('.pagination').remove();
      $('body').addClass('is--filtered');

    } else {
      $('.remove-all').removeClass('show');
      $('body').removeClass('is--filtered');
    }
    if($('.products .grid__item:visible').length) {
      $('.no-matches').hide();
    } else {
      $('.no-matches').show();
    }

    //theme.currencySwitcher.ajaxrefresh();
  }

  $('#collection-sidebar .remove-all').on('click',function(e) {
    e.preventDefault();
    $('#collection-sidebar .coll-filter').prop('checked',false).removeAttr('checked').eq(0).trigger('change');
    $('#collection-sidebar .remove').hide();
  });

  $('.filter-group .remove').on('click',function(e) {
    e.preventDefault();
    $(this).closest('.filter-group').find('.coll-filter').prop('checked',false).removeAttr('checked').eq(0).trigger('change');
    $(this).hide();
  });

  checkFilters();


  $('.filter--link').on('click',function(e) {
    e.preventDefault();
    $('.collection-main-wrapper').toggleClass('filter-sidebar-is-active');
  });

  $(document).on('change', '.coll-filter', function() {
    var newTags = [],
        ajaxhref = '/collections/'+collectionHandle;

    collFilters.each(function(i,v) {
      if($(this).is(':checked')) {
        newTags.push($(this).val());
      }
    });
    if (newTags.length || initialCollectionHTML ) {
      var query = newTags.join('+');
      var urlhref = '/collections/'+collectionHandle+'/'+query;
      ajaxhref = urlhref; //+ '?view=filter';
      $.ajax({
        url: ajaxhref,
        type:'GET',
        beforeSend: function() {
          $('.collection-preloader').fadeIn();
        },
        success: function(data) {
          //           console.log($(data).find('#Collection .products').html());
          $('#Collection .products').html($(data).find('#Collection .products').html());
          $('#Collection .collection--wrapper').html($(data).find('#Collection .collection--wrapper').html());
          $('.breadcrumb').html($(data).find('.breadcrumb').html());
          $('#Collection .pagination--wrapper').html($(data).find('#Collection .pagination--wrapper').html());

          var title = $(data).filter('title').text();
          document.title = title;
          window.history.pushState({url: "" + urlhref + ""}, title, urlhref);
          if ($('body').hasClass('currencies-enabled')) {
            theme.currencySwitcher.ajaxrefresh();
          }
          if(theme.isMobile()) {
            $('.filter--link').trigger('click');
          }
          checkFilters();
        },
        complete: function() {
          $('.collection-preloader').fadeOut();
        }
      });
    } else {
      $('#Collection').html(initialCollectionHTML);
      document.title = initialCollectionTitle;
      checkFilters();
    }
  }); 

  Cookies.set('last-collection',window.location.pathname,10);

};


theme.SidebarMenuSection = (function() {
  function SidebarMenuSection() {
    $('.drawer-nav__toggle').on('click', function() {
      $(this)
      .parent()
      .toggleClass('drawer-nav--expanded');

      if (
        $(this)
        .parent()
        .hasClass('drawer-nav--expanded')
      ) {
        $(this)
        .children('.drawer-nav__toggle-button')
        .attr('aria-expanded', true);
        $(this)
        .find('.icon-plus')
        .removeClass('icon-plus')
        .addClass('icon-minus');
      } else {
        $(this)
        .children('.drawer-nav__toggle-button')
        .attr('aria-expanded', false);
        $(this)
        .find('.icon-minus')
        .removeClass('icon-minus')
        .addClass('icon-plus');
      }
    });
  }

  return SidebarMenuSection;
})();

theme.SidebarMenuSection.prototype = _.assignIn(
  {},
  theme.SidebarMenuSection.prototype,
  {
    onSelect: function() {
      theme.RightDrawer.close();
      theme.SearchDrawer.close();
      theme.LeftDrawer.open();
    },

    onDeselect: function() {
      theme.LeftDrawer.close();

    }
  }
);

theme.HeaderSection = (function() {
  function Header() {
    theme.Header.init();
    theme.Search.init();
    theme.drawersInit();
  }

  Header.prototype = _.assignIn({}, Header.prototype, {
    onUnload: function() {
      theme.Header.unload();
    }
  });


  return Header;
})();

theme.FooterSection = (function() {

  theme.Footer.init();
  function Footer() {
  }

  Footer.prototype = _.assignIn({}, Footer.prototype, {
    onUnload: function() {
      theme.Footer.unload();
    }
  });


  return Footer;
})();

theme.Maps = (function() {
  var config = {
    zoom: 14
  };
  var apiStatus = null;
  var mapsToLoad = [];

  var errors = {
    addressNoResults: theme.strings.addressNoResults,
    addressQueryLimit: theme.strings.addressQueryLimit,
    addressError: theme.strings.addressError,
    authError: theme.strings.authError
  };

  var selectors = {
    section: '[data-section-type="map"]',
    map: '[data-map]',
    mapOverlay: '[data-map-overlay]'
  };

  var classes = {
    mapError: 'map-section--load-error',
    errorMsg: 'map-section__error errors text-center'
  };

  // Global function called by Google on auth errors.
  // Show an auto error message on all map instances.
  // eslint-disable-next-line camelcase, no-unused-vars
  window.gm_authFailure = function() {
    if (!Shopify.designMode) {
      return;
    }

    $(selectors.section).addClass(classes.mapError);
    $(selectors.map).remove();
    $(selectors.mapOverlay).after(
      '<div class="' +
      classes.errorMsg +
      '">' +
      theme.strings.authError +
      '</div>'
    );
  };

  function Map(container) {
    this.$container = $(container);
    this.$map = this.$container.find(selectors.map);
    this.key = this.$map.data('api-key');

    if (typeof this.key === 'undefined') {
      return;
    }

    if (apiStatus === 'loaded') {
      this.createMap();
    } else {
      mapsToLoad.push(this);

      if (apiStatus !== 'loading') {
        apiStatus = 'loading';
        if (typeof window.google === 'undefined') {
          $.getScript(
            'https://maps.googleapis.com/maps/api/js?key=' + this.key
          ).then(function() {
            apiStatus = 'loaded';
            initAllMaps();
          });
        }
      }
    }
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    $.each(mapsToLoad, function(index, instance) {
      instance.createMap();
    });
  }

  function geolocate($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data('address-setting');

    geocoder.geocode({ address: address }, function(results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }

  Map.prototype = _.assignIn({}, Map.prototype, {
    createMap: function() {
      var $map = this.$map;

      return geolocate($map)
      .then(
        function(results) {
          var mapOptions = {
            zoom: config.zoom,
            center: results[0].geometry.location,
            draggable: false,
            clickableIcons: false,
            scrollwheel: false,
            disableDoubleClickZoom: true,
            disableDefaultUI: true
          };

          var map = (this.map = new google.maps.Map($map[0], mapOptions));
          var center = (this.center = map.getCenter());

          //eslint-disable-next-line no-unused-vars
          var marker = new google.maps.Marker({
            map: map,
            position: map.getCenter()
          });

          google.maps.event.addDomListener(
            window,
            'resize',
            $.debounce(250, function() {
              google.maps.event.trigger(map, 'resize');
              map.setCenter(center);
              $map.removeAttr('style');
            })
          );
        }.bind(this)
      )
      .fail(function() {
        var errorMessage;

        switch (status) {
          case 'ZERO_RESULTS':
            errorMessage = errors.addressNoResults;
            break;
          case 'OVER_QUERY_LIMIT':
            errorMessage = errors.addressQueryLimit;
            break;
          case 'REQUEST_DENIED':
            errorMessage = errors.authError;
            break;
          default:
            errorMessage = errors.addressError;
            break;
        }

        // Show errors only to merchant in the editor.
        if (Shopify.designMode) {
          $map
          .parent()
          .addClass(classes.mapError)
          .html(
            '<div class="' +
            classes.errorMsg +
            '">' +
            errorMessage +
            '</div>'
          );
        }
      });
    },

    onUnload: function() {
      if (this.$map.length === 0) {
        return;
      }
      google.maps.event.clearListeners(this.map, 'resize');
    }
  });

  return Map;
})();


theme.Collection = (function() {
  function Collection(container) {
    var $container = (this.$container = $(container));
  }
  Collection.prototype = _.assignIn({}, Collection.prototype, {
    _onLoad: function() {
    },
    _onSelect: function() {
    }
  });
  return Collection;
})();

theme.Product = (function() {

  function Product(container) {
    var $container = (this.$container = $(container,'#quick-view--ProductSection-product-template'));
    var sectionId = $container.attr('data-section-id');
    var qty = 1;

    //console.log('product page');

    this.settings = {
      // Breakpoints from src/stylesheets/global/variables.scss.liquid
      mediaQueryMediumUp: 'screen and (min-width: 750px)',
      mediaQuerySmall: 'screen and (max-width: 749px)',
      bpSmall: false,
      enableHistoryState: false,
      namespace: '.slideshow-' + sectionId,
      sectionId: sectionId,
      sliderActive: false,
      zoomEnabled: false,
      addToCartFormId: '#AddToCartForm' + '-' + sectionId
    };

    this.selectors = {
      addToCart: '#AddToCart-' + sectionId,
      addToCartText: '#AddToCartText-' + sectionId,
      comparePrice: '#ComparePrice-' + sectionId,
      //originalPrice: '#ProductPrice-' + sectionId,
      originalPrice: '.product-price__original-label',
      SKU: '.product-single__sku',
      video: 'ProductVideo-'+sectionId,
      productVideo: '.product__video',
      productStatus: '[data-product-status]',
      originalPriceWrapper: '.product-price__price-' + sectionId,
      originalSelectorId: '#ProductSelect-' + sectionId,
      productImageWraps: '.product-single__photo',
      productSlick: '#product-slick',
      productPrices: '.product-single__price-' + sectionId,
      productThumbImages: '.product-single__thumbnail--' + sectionId,
      productThumbs: '.product-single__thumbnails-' + sectionId,
      productFeaturedImage: '.product-featured-img',
      productQty: '.js-qty',
      productQtyValue: '.js-qty__input',
      productQtyButton: '.js-qty__adjust',
      productQtyPlus: '.js-qty__adjust--plus',
      productQtyMinus: '.js-qty__adjust--minus',
      productThumbsWrapper: '.thumbnails-wrapper',
      productForm: '.product-single-form',
      productFormPreorder: '.product-form-product-pre-order-template',
      saleClasses: 'product-price__sale product-price__sale--single',
      saleLabel: '.product-price__sale-label-' + sectionId,
      singleOptionSelector: '.single-option-selector-' + sectionId,
      shopifyPaymentButton: '.shopify-payment-button',
      cartContainer: '#CartContainer',
      tabs: '.product-single__tabs',
      tabContent: '.product-single__tab-content',
      accordion: '.product-single__accordion',
      accordionHeader: '.product-single__accordion--heading',
      accordtionText: '.product-single__accordion--text',
      tabHeader: '.product-single__tab-header',
      sprBadge: '.spr-badge',
      relatedSlider: '.related-slider',
      relatedAdd: '.btn--small-add'
    };

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$('#ProductJson-' + sectionId).html()) {
      return;
    }

    this.productSingleObject = JSON.parse(
      document.getElementById('ProductJson-' + sectionId).innerHTML
    );

    this.settings.zoomEnabled = $(this.selectors.productImageWraps).hasClass(
      'js-zoom-enabled'
    );

    this._init();
    this._initBreakpoints();
    this._stringOverrides();
    this._initVariants();
    this._initImageSwitch();
    this._setActiveThumbnail();
    this._initTabs();
    this._initAccordion();
    theme.FancySwatches();



  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    _stringOverrides: function() {
      theme.productStrings = theme.productStrings || {};
      $.extend(theme.strings, theme.productStrings);
    },

    _init: function() {
      //console.log('theme.Product._init');
      if($('.rocker-thumbnails__image-wrap').length == 1){
  var get_length = $(".product_gallery_images").val();
if (typeof get_length === "undefined") {
var slides_show = 4;
    // ...
}else{
var set_slide = parseInt(get_length);
var slides_show  = get_length - 1 ;
}
        $(this.selectors.productSlick).slick({
          dots: false,
          arrows: false,
          swipeToSlide: true,
          accessibility: false,
          infinite:true,
          speed: 500,
          fade: true,
          asNavFor: '.rocker-thumbnails'
        }).fadeIn();

        $('.rocker-thumbnails').slick({
          arrows: true,
          slidesToShow: slides_show,
          slidesToScroll: 1,
          vertical: true,
          infinite:false,
          verticalScrolling: false,
          asNavFor: this.selectors.productSlick,
          focusOnSelect: true,
          responsive: [
            {
              breakpoint: 779,
              settings: {
                arrows: true,
                slidesToScroll: 1,
                slidesToShow: slides_show,
                vertical: false,
                asNavFor: this.selectors.productSlick,
                focusOnSelect: true
              }
            }
          ]
        });

        $(this.selectors.productSlick).on("beforeChange", function (event, slick){
          var iframe = $('.rocker-iframe-video')[0];
          var player = $f(iframe);
          player.api('pause'); 
        });

      }
      else if($('.newrocker-thumbnails__image-wrap').length == 1){
        $(this.selectors.productSlick).slick({
          dots: false,
          arrows: false,
          swipeToSlide: true,
          accessibility: false,
          infinite:true,
          speed: 500,
          fade: true,
          asNavFor: '.rocker-thumbnails'
        }).fadeIn();

        $('.rocker-thumbnails').slick({
          arrows: true,
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite:true,
          vertical: true,
          verticalScrolling: false,
          asNavFor: this.selectors.productSlick,
          focusOnSelect: true,
          responsive: [
            {
              breakpoint: 779,
              settings: {
                arrows: true,
                slidesToScroll: 1,
                slidesToShow: 4,
                vertical: false,
                asNavFor: this.selectors.productSlick,
                focusOnSelect: true
              }
            }
          ]
        });
      }
      else{
        $(this.selectors.productSlick).slick({
          dots: true,
          arrows: false,
          swipe: true,
          swipeToSlide: true,
          infinite:true,
          touchMove: true,
          draggable: true,
          accessibility: false
          // mobileFirst: true,
          // responsive: [
          //   {
          //     breakpoint: 1050,
          //     settings: {
          //       arrows: true
          //     }
          //   }
          // ]
          //prevArrow: '<button type="button" class="slick-prev"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><defs><style>.cls-1{fill:#231f20}</style></defs><path class="cls-1" d="M437.67 129.51a35 35 0 0 1 24.75 59.75L272.67 379l189.75 189.74a35 35 0 1 1-49.5 49.5L198.43 403.75a35 35 0 0 1 0-49.5l214.49-214.49a34.89 34.89 0 0 1 24.75-10.25z" transform="translate(-188.18 -129.51)" fill="#000000"/></svg></button>',
          //nextArrow: '<button type="button" class="slick-next"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 284.49 498.98"><defs><style>.cls-1{fill:#231f20}</style></defs><path class="cls-1" d="M223.18 628.49a35 35 0 0 1-24.75-59.75L388.17 379 198.43 189.26a35 35 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L247.93 618.24a34.89 34.89 0 0 1-24.75 10.25z" transform="translate(-188.18 -129.51)" fill="#000000"/></svg></button>'
        }).fadeIn();

      }





      if($('#product-video').length) {
        $(this.selectors.productSlick).on('afterChange', function(event, slick, currentSlide, nextSlide){

          var vid = $('#product-video').get(0);
          if($('.slick-active #product-video').length) {
            vid.play();
          } else {
            vid.pause();
          }

        });
      }

      var reviewsAutoPlaySpeed = 2000;
      if(productJSON.title.indexOf('Child + Junior') !== -1) {
        reviewsAutoPlaySpeed = 10000;
      }

      $('.reviews-slider').slick({
        dots: false,
        arrows: true,
        infinite: true,
        slidesToShow: 1,
        autoplay: 1,
        autoplaySpeed: reviewsAutoPlaySpeed,
        adaptiveHeight: false,
        prevArrow: prevArrowSVG,
        nextArrow: nextArrowSVG
      });

      var vimeoURL = 'https://vimeo.com/365065073';
      var watchVideoLink = $('<a class="pdp-video-link mfp-iframe" href="'+vimeoURL+'" aria-describedby="a11y-external-message" rel="noopener noreferrer" target="_blank"><svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path id="a" d="M0 0h16v16H0z"></path></defs><g fill="none" fill-rule="evenodd"><mask id="b" fill="#fff"><use xlink:href="#a"></use></mask><path d="M10.891 8.472l-3.994 2.306a.545.545 0 0 1-.817-.472V5.694c0-.419.454-.681.817-.472l3.994 2.307a.545.545 0 0 1 0 .943M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0" fill="#bf6f88" mask="url(#b)"></path></g></svg> Watch<span class="small--hide"> Video</span></a>');
      var newHeading = $('.product-description-0 h4').eq(0).wrap('<div class="flex small--display-block"></div>');
      //newHeading.append(watchVideoLink);
      $('.product-description-0 .flex').append(watchVideoLink);

      $(document).on('click','.mobile-accordion-heading',function(e) {
        var myTab = $(this).data('tab');
        $('.'+myTab).slideToggle('fast');
        $(this).toggleClass('open');
      });


      $(this.selectors.relatedSlider).slick({
        dots: false,
        arrows: true,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        prevArrow: prevArrowSVG,
        nextArrow: nextArrowSVG,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }

        ]
      }).fadeIn();





      if(!theme.isMobile()) {
        $('.js-zoom-enabled').each(function() {
          _enableZoom($(this));
        });
      }
      $(this.selectors.productForm).submit(function(e) {
        e.preventDefault();
        if(!$(this).find('#AddToCartText-product-template').hasClass('product--sold-out')) {
          if($(this).find('#AddToCart-product-template').hasClass('ready-to-add')) {
            $(this).find('.product-form__cart-submit').removeClass('ready-to-add');
            $(this).find('.addToCartText').text('Adding to Cart');
            var formID = $(this).attr('id');
            setTimeout(function() {
$('.upsell-wrap').slick('refresh'); //Working for slick 1.8.1
        }, 1500);
            theme.addItemFromForm(formID,true);
          }
        }
      });

      $(document).on('click',this.selectors.relatedAdd,function(e) {
        e.preventDefault();
        if($(this).hasClass('ready-to-add')) {
          $(this).removeClass('ready-to-add');
          $(this).text('Adding');
          var productID = $(this).data('variant-id');
          theme.addItem(productID);
        }
      });
      /*
      $(document).on('click',this.selectors.sprBadge,function(e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $("#shopify-product-reviews").offset().top - $('#shopify-section-header').height()
        }, 500);
      });
      */
      $(document).on('click','.loox-rating',function(e) {
        e.preventDefault();
        $('html, body').animate({
          scrollTop: $("#looxReviews").offset().top - $('#shopify-section-header').height()
        }, 500);
      });

      $(this.selectors.productQtyMinus).on('click',function(e) {
        e.preventDefault();
        qty = parseInt($('#quantity').val());
        if(qty > 1) {
          $('#Quantity').val(qty-1);
        } else {
          $('#Quantity').val(1);
        }


      });
      $(this.selectors.productQtyPlus).on('click',function(e) {
        e.preventDefault();
        qty = parseInt($('#Quantity').val());
        //console.log(qty+1);
        $('#Quantity').val(qty+1);
      });

      var keyPoints = $('.product-single__description p:contains("KEY POINTS")'),
          keyPointsUL = keyPoints.next(),
          constructed = $('.product-single__description p:contains("HOW IT IS CONSTRUCTED")'),
          constructedUL = constructed.next();
      if(keyPoints.length && keyPointsUL.length) {     
        var item = $('<div class="product-single__accordion--item"></div>');
        item.append('<h4 class="product-single__accordion--heading">Product Details <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" viewBox="0 0 20 20"><path fill="#444" d="M17.409 8.929h-6.695V2.258c0-.566-.506-1.029-1.071-1.029s-1.071.463-1.071 1.029v6.671H1.967C1.401 8.929.938 9.435.938 10s.463 1.071 1.029 1.071h6.605V17.7c0 .566.506 1.029 1.071 1.029s1.071-.463 1.071-1.029v-6.629h6.695c.566 0 1.029-.506 1.029-1.071s-.463-1.071-1.029-1.071z"></path></svg></h4>');
        keyPointsUL.appendTo(item).wrap('<div class="product-single__accordion--text" />');
        $('.product-single__accordion').append(item);
        keyPoints.hide();
      }

      if(constructed.length && constructedUL.length) {
        var item = $('<div class="product-single__accordion--item"></div>');
        item.append('<h4 class="product-single__accordion--heading">How It Is Constructed <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" viewBox="0 0 20 20"><path fill="#444" d="M17.409 8.929h-6.695V2.258c0-.566-.506-1.029-1.071-1.029s-1.071.463-1.071 1.029v6.671H1.967C1.401 8.929.938 9.435.938 10s.463 1.071 1.029 1.071h6.605V17.7c0 .566.506 1.029 1.071 1.029s1.071-.463 1.071-1.029v-6.629h6.695c.566 0 1.029-.506 1.029-1.071s-.463-1.071-1.029-1.071z"></path></svg></h4>');
        constructedUL.appendTo(item).wrap('<div class="product-single__accordion--text" />');
        $('.product-single__accordion').append(item);
        constructed.hide();
      }

      $('.product-single__accordion--item').each(function(i,v) {
        var o = $(this);
        var t = Shopify.handleize(o.find('.product-single__accordion--heading').text());
        o.addClass('psai-'+(i+1)).addClass(t);
      });

      $('.psai-5').insertBefore('.psai-2');
      $('.psai-4').insertBefore('.psai-2');
      $('.how-it-is-constructed').insertBefore('.size-info');


      //$("#pdp-badges").load("https://rockermama.com/ #awards-for-later");
      $.get('/',function(data) {
        var badges = $(data).find('#pdp-badges').html();
        $('#pdp-badges').html(badges);
      });

    },

    _initBreakpoints: function() {
      var self = this;

      enquire.register(this.settings.mediaQuerySmall, {
        match: function() {
          // initialize thumbnail slider on mobile if more than three thumbnails
          if ($(self.selectors.productThumbImages).length > 3) {
            self._initThumbnailSlider();
          }

          // destroy image zooming if enabled
          if (self.settings.zoomEnabled) {
            $(self.selectors.productImageWraps).each(function() {
              _destroyZoom(this);
            });
          }

          self.settings.bpSmall = true;
        },
        unmatch: function() {
          if (self.settings.sliderActive) {
            self._destroyThumbnailSlider();
          }

          self.settings.bpSmall = false;
        }
      });

      enquire.register(this.settings.mediaQueryMediumUp, {
        match: function() {
          if (self.settings.zoomEnabled) {
            $(self.selectors.productImageWraps).each(function() {
              _enableZoom(this);
            });
          }
        }
      });
    },
    _initAccordion: function() {
      if($(this.selectors.accordion).length) {
        $(this.selectors.accordionHeader).on('click',function(e) {
          e.preventDefault();
          $(this).toggleClass('active').next().slideToggle();
        });
      }
    },

    _initTabs: function() {
      if($(this.selectors.tabs).length) {
        $(this.selectors.tabHeader).on('click',function(e) {
          e.preventDefault();
          var myTab = $(this).attr('href');
          $('.tabs-header a').removeClass('active');
          $('.tab-content').removeClass('active').hide();
          $(this).addClass('active');
          $(myTab).fadeIn().addClass('active');
        });
      }
    },

    _initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState:false,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productSingleObject
      };

      this.variants = new slate.Variants(options);

      this.$container.on(
        'variantChange' + this.settings.namespace,
        this._updateAvailability.bind(this)
      );
      this.$container.on(
        'variantImageChange' + this.settings.namespace,
        this._updateImages.bind(this)
      );
      this.$container.on(
        'variantPriceChange' + this.settings.namespace,
        this._updatePrice.bind(this)
      );
      this.$container.on(
        'variantSKUChange' + this.settings.namespace,
        this._updateSKU.bind(this)
      );
    },

    _initImageSwitch: function() {
      if (!$(this.selectors.productThumbImages).length) {
        return;
      }

      var self = this;

      $(this.selectors.productThumbImages).on('click', function(evt) {
        evt.preventDefault();
        var $el = $(this);

        var imageId = $el.data('thumbnail-id');

        self._switchImage(imageId);
        self._setActiveThumbnail(imageId);
      });
    },

    _setActiveThumbnail: function(imageId) {
      var activeClass = 'active-thumb';

      $('.product-thumbnail__link').on('click',function(e) {
        e.preventDefault();
        var thumbID = $(this).data('id');
        $('#product-slick').slick('slickGoTo',thumbID);
      });

      // If there is no element passed, find it by the current product image
      if (typeof imageId === 'undefined') {
        imageId = $(this.selectors.productImageWraps + ":not('.hide')").data(
          'image-id'
        );
      }

      var $thumbnail = $(
        this.selectors.productThumbImages +
        "[data-thumbnail-id='" +
        imageId +
        "']"
      );

      $(this.selectors.productThumbImages)
      .removeClass(activeClass)
      .removeAttr('aria-current');

      $thumbnail.addClass(activeClass);
      $thumbnail.attr('aria-current', true);
    },

    _switchImage: function(imageId) {
      var $newImage = $(
        this.selectors.productImageWraps + "[data-image-id='" + imageId + "']",
        this.$container
      );
      var $otherImages = $(
        this.selectors.productImageWraps +
        ":not([data-image-id='" +
        imageId +
        "'])",
        this.$container
      );
      $newImage.removeClass('hide');
      $newImage.find(this.selectors.productFeaturedImage).focus();
      $otherImages.addClass('hide');
    },

    _initThumbnailSlider: function() {
      var options = {
        slidesToShow: 4,
        slidesToScroll: 3,
        infinite: false,
        prevArrow: '.thumbnails-slider__prev--' + this.settings.sectionId,
        nextArrow: '.thumbnails-slider__next--' + this.settings.sectionId,
        responsive: [
          {
            breakpoint: 321,
            settings: {
              slidesToShow: 3
            }
          }
        ]
      };

      $(this.selectors.productThumbs).slick(options);

      // Accessibility concerns not yet fixed in Slick Slider
      $(this.selectors.productThumbsWrapper, this.$container)
      .find('.slick-list')
      .removeAttr('aria-live');
      $(this.selectors.productThumbsWrapper, this.$container)
      .find('.slick-disabled')
      .removeAttr('aria-disabled');

      this.settings.sliderActive = true;
    },

    _destroyThumbnailSlider: function() {
      $(this.selectors.productThumbs).slick('unslick');
      this.settings.sliderActive = false;

      // Accessibility concerns not yet fixed in Slick Slider
      $(this.selectors.productThumbsWrapper, this.$container)
      .find('[tabindex="-1"]')
      .removeAttr('tabindex');
    },

    _liveRegionText: function(variant) {
      // Dummy content for live region
      var liveRegionText = '[Availability] [Regular] [$$] [Sale] [$]';

      if (!variant) {
        liveRegionText = theme.strings.unavailable;
        return liveRegionText;
      }

      // Update availability
      var availability = variant.available ? '' : theme.strings.soldOut + ',';
      liveRegionText = liveRegionText.replace('[Availability]', availability);

      // Update pricing information
      var regularLabel = '';
      var regularPrice = theme.Currency.formatMoney(
        variant.price,
        theme.moneyFormat
      );
      var saleLabel = '';
      var salePrice = '';

      if (variant.compare_at_price > variant.price) {
        regularLabel = theme.strings.regularPrice;
        regularPrice =
          theme.Currency.formatMoney(
          variant.compare_at_price,
          theme.moneyFormat
        ) + ',';
        saleLabel = theme.strings.sale;
        salePrice = theme.Currency.formatMoney(
          variant.price,
          theme.moneyFormat
        );
      }

      liveRegionText = liveRegionText
      .replace('[Regular]', regularLabel)
      .replace('[$$]', regularPrice)
      .replace('[Sale]', saleLabel)
      .replace('[$]', salePrice)
      .trim();

      return liveRegionText;
    },

    _updateLiveRegion: function(evt) {
      var variant = evt.variant;
      var liveRegion = this.container.querySelector(
        this.selectors.productStatus
      );
      liveRegion.textContent = this._liveRegionText(variant);
      liveRegion.setAttribute('aria-hidden', false);

      // hide content from accessibility tree after announcement
      setTimeout(function() {
        liveRegion.setAttribute('aria-hidden', true);
      }, 1000);
    },

    _updateAddToCart: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(this.selectors.productPrices)
        .removeClass('visibility-hidden')
        .attr('aria-hidden', 'false');

        if (variant.available) {
          $(this.selectors.addToCart).prop('disabled', false).show();
          // if(theme.strings.preOrder) {
          //   $(this.selectors.addToCartText).text(theme.strings.preOrderText);
          //   console.log('ftft');
          // } else {
            $(this.selectors.addToCartText).text(theme.strings.addToCart);
          // }
          $(this.selectors.shopifyPaymentButton, this.$container).show();
          $(this.selectors.addToCartText).addClass('ready-to-add');
                $(".upsell-wrap .slick-prev").trigger('click');

        } else {
          $(this.selectors.addToCartText).text(theme.strings.soldOut).removeClass('ready-to-add');
          // The variant doesn't exist, disable submit button and change the text.
          // This may be an error or notice that a specific variant is not available.
          //$(this.selectors.addToCart).prop('disabled', true);
          //$(this.selectors.addToCart).prop('disabled', true);
          //$(this.selectors.addToCartText).text(theme.strings.soldOut).parent().hide();
          //$(this.selectors.shopifyPaymentButton, this.$container).hide();
        }
      } else {
        $(this.selectors.addToCart).prop('disabled', true);
        $(this.selectors.addToCartText).text(theme.strings.unavailable);
        $(this.selectors.productPrices)
        .addClass('visibility-hidden')
        .attr('aria-hidden', 'true');
        //$(this.selectors.shopifyPaymentButton, this.$container).hide();
      }
    },

    _updateAvailability: function(evt) {
      // update form submit
      this._updateAddToCart(evt);
      // update live region
      this._updateLiveRegion(evt);
    },

    _updateImages: function(evt) {
      var variant = evt.variant;
      var imageId = variant.featured_image.id;

      this._switchImage(imageId);
      this._setActiveThumbnail(imageId);
    },

    _updatePrice: function(evt) {
      var variant = evt.variant;

      // Update the product price
      $(this.selectors.originalPrice).html(
        theme.Currency.formatMoney(variant.price, theme.moneyFormat)
      );


      // Update and show the product's compare price if necessary
      if (variant.compare_at_price > variant.price) {
        $(this.selectors.comparePrice)
        .html(
          theme.Currency.formatMoney(
            variant.compare_at_price,
            theme.moneyFormat
          )
        )
        .removeClass('hide');

        $(this.selectors.originalPriceWrapper).addClass(
          this.selectors.saleClasses
        );

        $(this.selectors.saleLabel).removeClass('hide');
      } else {
        $(this.selectors.comparePrice).addClass('hide');
        $(this.selectors.saleLabel).addClass('hide');
        $(this.selectors.originalPriceWrapper).removeClass(
          this.selectors.saleClasses
        );
      }
    },

    _updateSKU: function(evt) {
      var variant = evt.variant;

      // Update the sku
      $(this.selectors.SKU).html(variant.sku);
    },

    onUnload: function() {
      this.$container.off(this.settings.namespace);
    }
  });

  function _enableZoom(el) {
    var zoomUrl = $(el).data('zoom');
    $(el).zoom({
      url: zoomUrl
    });
  }

  function _destroyZoom(el) {
    $(el).trigger('zoom.destroy');
  }

  return Product;
})();


theme.initCart = function() {
  /*
    ajaxCart.init({
      moneyFormat: theme.settings.moneyFormat
    });

  if (!theme.cookiesEnabled()) {
    theme.cache.$cartContainer.addClass(theme.cache.cartNoCookies);
    theme.cache.$cartSectionTemplate.addClass(theme.cache.cartNoCookies);
  }*/
};

theme.FAQ = (function() { 
  var selectors = {
    question: '.faq__question',
    openClass: 'faq--open'
  }
  function FAQ(container) {
    $(document).on('click',selectors.question,function(e) {
      e.preventDefault();
      $(this).parent().toggleClass(selectors.openClass)
      $(this).next().slideToggle('fast');
    });
  }
  FAQ.prototype = _.assignIn({}, FAQ.prototype, {

  });

  return FAQ;
})();

theme.SimpleAsCopy = (function() { 
  var selectors = {
    inner: '.homepage-simple-as__inner',
    outer: '.homepage-simple-as',
    copyFrom: '.how-it-works--simple-as'
  }
  function SimpleAsCopy(container) {
    var ajaxhref = '/pages/how-it-works';
    $.get(ajaxhref, function(data) {   

      $(selectors.inner).html($(data).find(selectors.copyFrom).html());


    }).done(function() {
      $(selectors.outer + ' .preloader').fadeOut();
      $(selectors.inner).fadeIn();
    });

  }
  SimpleAsCopy.prototype = _.assignIn({}, SimpleAsCopy.prototype, {

  });

  return SimpleAsCopy;
})();

theme.HomepageVideoBlock = (function() { 
  var selectors = {
    inner: '.homepage-simple-as__inner',
    outer: '.homepage-simple-as',
    copyFrom: '.how-it-works--simple-as'
  }
  function HomepageVideoBlock(container) {

  }
  HomepageVideoBlock.prototype = _.assignIn({}, HomepageVideoBlock.prototype, {
    onLoad: function() {
      //$('.fitvids').fitVids();
    },
    onSelect: function() {
      //$('.fitvids').fitVids();
    }
  });

  return HomepageVideoBlock;
})();


theme.NewsletterPopup = (function() {
  var seconds = Number();
  var expiration = Number();
  var popup_delay = seconds*1000;

  function NewsletterPopup(container) {
    if(Cookies.get('newsletter') != 'hide' && showNewsletterPopup === true) {
      setTimeout(function(){ 
        showThePopup();
      }, popup_delay);
    } 
    if(newsletterOnClick) {
      $(document).on('click','.announcement-bar--link',function(e) {
        e.preventDefault();
        showThePopup();
        return false;
      });
    }
    $('#popup_signup input[name="g"]').val('Y9kHWC');
  }
  function setTheCookie() {
    Cookies.set('newsletter','hide',{ expires: expiration });
  }
  function showThePopup() {
    $.magnificPopup.open({
      items: {
        src: '#newsletter-popup'
      },
      removalDelay: 500,
      showCloseBtn: true,
      closeBtnInside: true,
      mainClass: 'mfp-with-zoom',
      type: 'inline'
    }); 
    setTheCookie();
  }
  NewsletterPopup.prototype = _.assignIn({}, NewsletterPopup.prototype, {
    onLoad: function() {
      //console.log('load');
    },
    onSelect: function() {
      showThePopup();
    }
  });
  return NewsletterPopup;
})();

/*

theme.HelperSection = (function() {
  function HelperSection() {
    //theme.Header.init();
    //theme.Search.init();
    //theme.drawersInit();
  }

  HelperSection.prototype = _.assignIn({}, HelperSection.prototype, {
    onUnload: function() {
      theme.HelperSection.unload();
    }
  });


  return HelperSection;
})();

*/


theme.Stockists = (function() {
  var config = {
    mediaQuerySmall: 'screen and (max-width: 749px)',
    mediaQueryMediumUp: 'screen and (min-width: 750px)',
    slideCount: 0,
    spreadsheetID: '1iM4iKpgL58wV0b0aVVWaZmWA5M9LfN1oijFaAvqTZ-U'
  };
  var selectors = {
    link: '.stockist-link',
    tab: '.stockist-tab'
  }
  var defaults = {
    accessibility: true,
    arrows: false,
    dots: true,
    autoplay: false,
    touchThreshold: 20,
    slidesToShow: 3,
    slidesToScroll: 3
  };
  function Stockists(container) {
    //console.log('stockists rule!');

    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var spreadsheetID = config.spreadsheetID;

    function toTitleCase(str) {
      return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
    }

    $(selectors.link).on('click',function(e) {
      e.preventDefault();
      var target = $($(this).attr('href'));
      $(selectors.link).removeClass('active');
      $(selectors.tab).removeClass('active').hide();

      $(this).addClass('active');
      target.addClass('active').fadeIn();
    });

    //console.log(container);

    GetStockists('1','domestic');

    function GetStockists(worksheet,location) {

      var url = "//spreadsheets.google.com/feeds/list/" + spreadsheetID + "/"+worksheet+"/public/values?alt=json"; //this is the part that's changed
      var innerSelector = '#'+location+'-inner',
          innerSelect = null;
      if(location == 'domestic') {
        innerSelect = '#state-picker';
      } else if(location == 'international') {
        innerSelect = '#country-picker';
      } else if(location == 'online') {
      }

      var addresses = [],
          states = [],
          cities = [];

      $.getJSON(url, function(data) {
        //console.log(data);
        var entry = data.feed.entry;
        $(entry).each(function(){
          var website = false,
              name = false,
              address = false,
              city = false,
              state = null,
              stateHandle = false,
              zip = false,
              phone = false,
              country = false,
              countryHandle = false,
              region = false,
              cityHandle = false,
              simple_address = false;

          if(this.gsx$name) {
            name = toTitleCase(this.gsx$name.$t);
          }

          if(this.gsx$addr1) {
            address = toTitleCase(this.gsx$addr1.$t);
            simple_address = address;
            address = address.replace(/(?:\r\n|\r|\n)/g, '<br />');
          }


          if(this.gsx$city) {
            city = toTitleCase(this.gsx$city.$t);
            cityHandle = slugify(city);
          }


          if(this.gsx$website) 
            website = this.gsx$website.$t;


          if(this.gsx$state) {
            state = this.gsx$state.$t.toUpperCase();
            stateHandle = state.replace(/\s+/g, '-').toLowerCase();
          }

          if(this.gsx$zip) {
            zip = this.gsx$zip.$t;
          }

          if(this.gsx$region) 
            region = this.gsx$region.$t;

          if(this.gsx$country) {
            country = this.gsx$country.$t;
            countryHandle = country.replace(/\s+/g, '-').toLowerCase();
          }

          if(this.gsx$phone) {
            phone = this.gsx$phone.$t;
          }

          if(location == 'international') {
            if(this.gsx$region) {
              state = this.gsx$region.$t;
              stateHandle = slugify(state);
            }

            city = this.gsx$country.$t;
            cityHandle = slugify(city);
          }

          if(location == 'domestic' || location == 'international') {
            var cityDivId = '#'+cityHandle;
            var mapsLink = "<a target='_blank' href='http://maps.google.com/?q=" + simple_address +"'>"+ address +"<br/></a>";
            var entrydiv = "<div class='stockist dontsplit' data-state='"+state+"' data-country='"+country+"' data-city='"+city+"' data-name='"+$.trim(name.replace('The',''))+"'>";
            if(website) {
              entrydiv += "<a class='name' href='"+website+"'>" + name + "</a>";
            } else {
              entrydiv += name + '<br/>';
            }
            entrydiv +=  address + '<br/>';

            if(phone) {
              entrydiv += phone;
            }
            entrydiv += "</div>";

            if(!addresses.includes(address)) {
              addresses.push(address);
              var st = '#'+stateHandle;
              if(!states.includes(state)) {
                states.push(state);
                $('#'+location+'-inner').append('<div id="'+stateHandle+'" class="state"><h3>'+state+'</h3><div class="state-entries"></div></div>');
              }
              if(!cities.includes(city)) {
                cities.push(city);
                var cityDiv = "<div id='"+cityHandle+"' class='city-div'><h5 class='pink'>"+city+"</h5><div class='city-inner flex'></div></div>";
                $(st).find('.state-entries').append(cityDiv);
              }
              $('#'+cityHandle).find('.city-inner').append(entrydiv);
            }

            $(innerSelector + ' .state').sort(sort_id).appendTo(innerSelector);            

            $(innerSelector + ' .city-div').each(function(i,v) {
              var me = $(this);
              var inner = $(this).find('.city-inner');
              me.find('.stockist').sort(sort_name).appendTo(inner);
              var myStores = me.find('.stockist');
            });

          } // if location == 'domestic' || location == 'international'

          if(location == 'online') {
            var entryDiv = "<div class='stockist online'><h4>"+name+"</h4><a href='"+website+"'>"+website+"</a></div>";
            $(innerSelector).append(entryDiv);
          }
        });

        $(innerSelector + ' .state').each(function(i,v) {
          $(innerSelect).append("<option value='"+$(this).attr('id')+"'>"+$(this).find('h3').text()+"</option>");
          var me = $(this);
          me.find('.city-div').sort(sort_id).appendTo(me);
        });

        $('.preloader').fadeOut();

        if(location == 'domestic') {
          $('#domestic-inner').fadeIn();
          GetStockists('2','international');
        } else if(location == 'international') {
          $(innerSelector).parent().hide();
          GetStockists('3','online');
        } else if (location == 'online') {
          $(innerSelector).parent().hide();
          return false;
        }
      });




      $('#state-picker,#country-picker').on('change',function() {
        //console.log($(this).val());
        var myTab = $(this).closest('.stockist-tab');
        if($(this).val() == 'all') {
          myTab.find('.state').fadeIn();
        } else {
          myTab.find('.state').hide();
          myTab.find('#'+$(this).val()).fadeIn();
          $(window).resize();
        }
      });


    }
    //}
  }

  Stockists.prototype = _.assignIn({}, Stockists.prototype, {
    onUnload: function() {
      theme.Stockists.unload();
    },
    onBlockSelect: function(evt) {
      //console.log('boo');
    }

  });

  return Stockists;
})();


theme.Quotes = (function() {

  var config = {
    mediaQuerySmall: 'screen and (max-width: 749px)',
    mediaQueryMediumUp: 'screen and (min-width: 750px)',
    slideCount: 0
  };
  var defaults = {
    accessibility: true,
    arrows: true,
    dots: false,
    autoplay: true,
    touchThreshold: 20,
    adaptiveHeight: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: prevArrowSVG,
    nextArrow: nextArrowSVG
  };

  function Quotes(container) {
    //console.log('Quotes');
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var wrapper = (this.wrapper = '.quotes-wrapper');
    var slider = (this.slider = '#Quotes-' + sectionId);
    var $slider = $(slider, wrapper);

    var sliderActive = false;
    var mobileOptions = $.extend({}, defaults, {
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true
    });

    config.slideCount = $slider.data('count');

    // Override slidesToShow/Scroll if there are not enough blocks
    if (config.slideCount < defaults.slidesToShow) {
      defaults.slidesToShow = config.slideCount;
      defaults.slidesToScroll = config.slideCount;
    }

    $slider.on('init', this.a11y.bind(this));

    enquire.register(config.mediaQuerySmall, {
      match: function() {
        initSlider($slider, mobileOptions);
      }
    });

    enquire.register(config.mediaQueryMediumUp, {
      match: function() {
        initSlider($slider, defaults);
      }
    });

    function initSlider(sliderObj, args) {
      if (sliderActive) {
        sliderObj.slick('unslick');
        sliderActive = false;
      }

      sliderObj.slick(args);
      sliderActive = true;
    }
  }

  Quotes.prototype = _.assignIn({}, Quotes.prototype, {
    onUnload: function() {
      enquire.unregister(config.mediaQuerySmall);
      enquire.unregister(config.mediaQueryMediumUp);

      $(this.slider, this.wrapper).slick('unslick');
    },

    onBlockSelect: function(evt) {
      // Ignore the cloned version
      var $slide = $(
        '.quotes-slide--' + evt.detail.blockId + ':not(.slick-cloned)'
      );
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      $(this.slider, this.wrapper).slick('slickGoTo', slideIndex);
    },

    a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = $(this.wrapper, this.$container);

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    }
  });

  return Quotes;
})();

theme.Article = (function() {
  var selectors = {
    prevNext: '.article__btn',
    prevBtn: '.article__prev-btn',
    nextBtn: '.article__next-btn',
    articleContent: '.article--inner',
    sectionWrapper: '#MainContent',
    preloader: '.preloader',
    frankiesGirlSelect: '.frankies-girl--dropdown'
  }
  function Article(container) {
    var self = this;
    if($(selectors.frankiesGirlSelect).length) {
      $(document).on('change',selectors.frankiesGirlSelect,function(e) {
        e.preventDefault();
        self._articleAjax($(this).val());

      });
    }
    $(document).on('click',selectors.prevNext,function(e) {
      e.preventDefault();
      self._articleAjax($(this).attr('href'));
    });
  }
  Article.prototype = _.assignIn({}, Article.prototype, {
    _articleAjax: function(page) {
      var ajaxhref = page;
      $.ajax({
        url: ajaxhref,
        type:'GET',
        beforeSend: function() {
          $(selectors.preloader).fadeIn();
          $(selectors.articleContent).removeClass('slide-in').addClass('slide-out').addClass('transitioning');
        },
        success: function(data) {
          $(selectors.articleContent).removeClass('slide-out');
          $(selectors.articleContent).html($(data).find(selectors.articleContent).html());

          var title = $(data).filter('title').text();
          document.title = title;
          window.history.pushState({url: "" + ajaxhref + ""}, title, ajaxhref);

          if($(data).find('.article__prev-btn').hasClass('has-prev')) {
            $(selectors.prevBtn).html($(data).find(selectors.prevBtn).html());
            $(selectors.prevBtn).attr('href',$(data).find(selectors.prevBtn).attr('href')).fadeIn();
          } else {
            $(selectors.prevBtn).removeClass('has-prev').fadeOut();
          }
          if($(data).find('.article__next-btn').hasClass('has-next')) {
            $(selectors.nextBtn).html($(data).find(selectors.nextBtn).html());
            $(selectors.nextBtn).attr('href',$(data).find(selectors.nextBtn).attr('href')).fadeIn();

          } else {
            $(selectors.nextBtn).removeClass('has-next').fadeOut();
          }

        },
        complete: function() {
          $(selectors.articleContent).addClass('slide-in');
          $(selectors.preloader).fadeOut('slow',function() {
            $(selectors.articleContent).removeClass('transitioning').removeClass('slide-in');
          });
          $("html, body").animate({ scrollTop: 0 }, "slow");
        }
      });
    }

  });

  return Article;
})();

theme.PressPage = function() {
  if($('#shopify-section-press-template').length) {
    var pressGrid = $('.press-grid').masonry({
      // set itemSelector so .grid-sizer is not used in layout
      itemSelector: '.press-grid__item',
      // use element for option
      columnWidth: '.press-grid__sizer',
      percentPosition: true,
      gutter: 60,
      stagger: 30
    });
    var moreBtn = '.press--load-more';
    $(document).on('click', moreBtn, function(e) {
      e.preventDefault();
      var ajaxhref = $(this).attr('href');
      //$('.pagination').remove();
      $(moreBtn).fadeOut();
      $.get(ajaxhref, function(data) {
        var newPressItems = $(data).find('.press-grid__item');
        var newPagination = $(data).find(moreBtn);
        $('.press-grid').append(newPressItems).masonry('appended', newPressItems);
        if(newPagination.length) {
          $(moreBtn).attr('href',newPagination.attr('href')).fadeIn();
        } else {
          //console.log('no mas pages');
          $(moreBtn).hide().remove();	    
        }
      }).done(function() {

      });

    });
  }

};

theme.slideshows = {};

theme.SlideshowSection = (function() {
  function SlideshowSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var slideshow = (this.slideshow = '#Slideshow-' + sectionId);

    $('.slideshow__video', slideshow).each(function() {
      var $el = $(this);
      theme.SlideshowVideo.init($el);
      theme.SlideshowVideo.loadVideo($el.attr('id'));
    });

    theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
  }

  return SlideshowSection;
})();

theme.SlideshowSection.prototype = _.assignIn(
  {},
  theme.SlideshowSection.prototype,
  {
    onUnload: function() {
      delete theme.slideshows[this.slideshow];
    },

    onBlockSelect: function(evt) {
      var $slideshow = $(this.slideshow);

      // Ignore the cloned version
      var $slide = $(
        '.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)'
      );
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
    },

    onBlockDeselect: function() {
      // Resume autoplay
      $(this.slideshow).slick('slickPlay');
    }
  }
);

theme.IndexBadges = (function() {
  function IndexBadges(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var slideshow = (this.slideshow = '#Slideshow-' + sectionId);
    var settings = {
      arrows: true,
      dots: false,
      slidesToShow: 6,
      autoplay: true,
      slidesToScroll: 1,
      infinite: true,
      prevArrow: '<button type="button" class="slick-prev">'+prevArrowSVG+'</button>',
      nextArrow: '<button type="button" class="slick-next">'+nextArrowSVG+'</button>',
      responsive: [
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    };
    /*
    this.$slideshow.on('beforeChange', beforeChange.bind(this));
    this.$slideshow.on('init', slideshowA11y.bind(this));
    this.$slideshow.slick(this.settings);
    */

    //this.$pause.on('click', this.togglePause.bind(this));
    $('.index-badges-carousel').slick(settings);
  }

  return IndexBadges;
})();

theme.IndexBadges.prototype = _.assignIn(
  {},
  theme.IndexBadges.prototype,
  {
    onUnload: function() {
      delete theme.slideshows[this.slideshow];
    },

    onBlockSelect: function(evt) {
      var $slideshow = $(this.slideshow);

      // Ignore the cloned version
      var $slide = $(
        '.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)'
      );
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
    },

    onBlockDeselect: function() {
      // Resume autoplay
      $(this.slideshow).slick('slickPlay');
    }
  }
);


function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}


var sections = new theme.Sections();

$(document).ready(function() {


  sections.register('cart-template', theme.Cart);
  sections.register('product', theme.Product);
  sections.register('collection-template', theme.Filters);
  sections.register('collection-template', theme.Collection);
  sections.register('product-template', theme.Product);
  sections.register('header-section', theme.HeaderSection);
  sections.register('footer-section', theme.FooterSection);
  sections.register('map', theme.Maps);
  sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('collection',theme.FeaturedCollectionSlider);
  sections.register('media-testimonial',theme.MediaSlider);
  sections.register('quotes', theme.Quotes);
  sections.register('index-badges',theme.IndexBadges);
  sections.register('page-faq', theme.FAQ);
  sections.register('page-stockists',theme.Stockists);
  sections.register('article-template',theme.Article);
  sections.register('newsletter-popup',theme.NewsletterPopup);
  sections.register('homepage-simple-as',theme.SimpleAsCopy);
  sections.register('homepage-video-block',theme.HomepageVideoBlock);

});

function Utils() {

}

Utils.prototype = {
  constructor: Utils,
  isElementInView: function (element, fullyInView) {
    var pageTop = $(window).scrollTop();
    var pageBottom = pageTop + $(window).height();
    var elementTop = $(element).offset().top;
    var elementBottom = elementTop + $(element).height();

    if (fullyInView === true) {
      return ((pageTop < elementTop) && (pageBottom > elementBottom));
    } else {
      return ((elementTop <= pageBottom) && (elementBottom >= pageTop));
    }
  }
};

var Utils = new Utils();




theme.collapsingHeader = function() {
  var headerElement = '#shopify-section-header',
      collapseAfter = $(headerElement).outerHeight()
  if (document.body.scrollTop > collapseAfter || document.documentElement.scrollTop > collapseAfter) {
    $(headerElement).addClass('is-collapsed');
  } else {
    if(!$('body').hasClass('js-drawer-open-left')) {
      $(headerElement).removeClass('is-collapsed');
    }
  }
};

theme.infiniteScroll = function() {
  var hasPagination = false;
  if($('.pagination').length) {	
    $('.pagination--wrapper').show();
    var ajaxhref = false,
        paged = false,
        productGrid = '.products',
        wrapper = '#Collection',
        isElementInView = Utils.isElementInView($('.pagination'), true);
    if(paged == false && isElementInView) {
      var ajaxhref = $('.pagination .paginate-next').attr('href');
      $('.pagination').remove();

      $.get(ajaxhref, function(data) {   
        paged = true;
        var newCollection = $(data).find(productGrid).html();
        var newPagination = $(data).find('.pagination--wrapper').html();
        $(productGrid).append(newCollection);
        $('.pagination--wrapper').html(newPagination);
        paged = false;
      }).done(function() {
        if ($('body').hasClass('currencies-enabled')) {
          theme.currencySwitcher.ajaxrefresh();
        }
      });
    }
  } else {
    $('.pagination--wrapper').fadeOut();
  }
};

function simpleParallax(intensity, element) {
  $(window).scroll(function() {
    var scrollTop = $(window).scrollTop();
    var imgPos = scrollTop / intensity + 'px';
    element.css('transform', 'translateY(' + imgPos + ')');
  });
};



theme.windowScrolling = function() {
  var scrollTimeout;
  var throttle = 250;
  $(window).on('scroll', function () {
    if (!scrollTimeout) {
      scrollTimeout = setTimeout(function () {
        theme.collapsingHeader();
        theme.infiniteScroll();
        scrollTimeout = null;
      }, throttle);
    }
  });
};



theme.itsSelectric = function() {
  $('.selectric').selectric({
    disableOnMobile: false,
    nativeOnMobile: false
  });
};

theme.productHovers = function() {
  var $product = $('.product'),
      timer = 1;

  $(document).on('mouseenter','.product', function() {
    $(this).find('.grid-view-item__image-hover').addClass('lazyload');
  });


  

};



theme.cookiesPopup = function() {
  var showCookieNotice = false;
  var cookiesPopup = '.cookies-popup';
  var expiration = Number(60);
  if(Cookies.get('cookie-popup') != 'checked') {
    showCookieNotice = true;
    $(cookiesPopup).show();
  }
  //console.log(showCookieNotice);
  $('.cookies-popup--close,.cookies-popup .btn--secondary').on('click',function(e) {
    e.preventDefault();
    Cookies.set('cookie-popup','checked', { expires: expiration });
    $(cookiesPopup).fadeOut();
  });

};

theme.SearchFilters = function() {
  var selectors = {
    product: '.template-search .product',
    filterElem: '.coll-filter',
    filterWrapper: '.search-filters--wrapper',
    colorFilter: '#color-filter',
    sizeFilter: '#size-filter'
  };
  var colors = [],
      sizes = [],
      searchTerms = $('#SearchInput').val();

  $(selectors.product).each(function(i,v) {
    var myColors = $(this).data('colors').split(',');
    $.each(myColors,function(ci,cv) {
      var colorHandle = cv.replace(/ /g, '-').toLowerCase();
      if($.inArray(colorHandle,colors) < 0) {
        colors.push(colorHandle);
      }
    });
    var mySizes = $(this).data('sizes').split(',');
    $.each(mySizes,function(ci,cv) {
      var sizeHandle = cv.replace(/ /g, '-').toLowerCase();
      if($.inArray(sizeHandle,colors) < 0) {
        sizes.push(sizeHandle);
      }
    });
  });

  $(selectors.filterElem).each(function(i,v) {
    $(this).parent().hide();
    var valueHandle = $(this).val().replace(/ /g, '-').toLowerCase();
    if($.inArray(valueHandle,colors) >= 0 || $.inArray(valueHandle,sizes) >= 0) {
      $(this).parent().show();
    }
  });

  $(selectors.colorFilter + ' ' + selectors.filterElem).on('click',function(e) {
    //e.preventDefault();

    var color = $(this).data('color');
    $(selectors.product).parent().hide();
    $(selectors.product + '[data-colors*="' + color + '"]').parent().show();
    $('.remove-all').addClass('show');
    $(this).closest('.filter-group').find('.remove').show();


  });
  $(selectors.sizeFilter + ' ' + selectors.filterElem).on('click',function(e) {
    //e.preventDefault();

    var size = $(this).data('size');
    $(selectors.product).parent().hide();
    $(selectors.product + '[data-sizes*="' + size + '"]').parent().show();
    $('.remove-all').addClass('show');
    $(this).closest('.filter-group').find('.remove').show();


  });

  $(selectors.filterWrapper + ' .remove-all').on('click',function(e) {
    e.preventDefault();
    $(selectors.product).parent().show();
    $(this).removeClass('show');
    $(selectors.filterWrapper).find('.remove').hide();
    $(selectors.filterWrapper).find(selectors.filterElem).prop('checked',false);
  });

  $(selectors.filterWrapper + ' .remove').on('click',function() {
    $(this).closest('.filter-group').find(selectors.filterElem).prop('checked',false);
    $(this).hide();
    if($(selectors.filterElem+':checked').length <= 0) {
      $(selectors.filterWrapper + ' .remove-all').removeClass('show');
      $(selectors.product).parent().show();
    }
  });




};


theme.quickView = function(){

  var closePopupOpenDrawer = true;
  var myColor = false;
  var pre_order = false;
  var pre_order_text = false;
  var addText = "Add to Cart";

  $(document).on('click','.qv-continue-shopping',function(e) {
    e.preventDefault();
    $.magnificPopup.close();
  });
  $(document).on('click','.quick-view',function(e) {

    //$(".quick-view").click(function(e){
    var product_handle = $(this).data('handle');
    myColor = $(this).data('color');

    var productJSON = null;
    $('#quick-view').addClass(product_handle);
    var collection_handle = $('.coll').data('handle');
    jQuery.getJSON('/products/' + product_handle + '.js', function(product) {
      $('#qv-product-json').html(JSON.stringify(product));
      productJSON = JSON.stringify(product);
      var title = product.title;
      var color = false;
      if(product.title.indexOf('|') > 0) {
                               title = product.title.split('|')[0].trim();
                               color = product.title.split('|')[1].trim();
                               } 
                               var type = product.type;
                               var price = 0;
                               var original_price = 0;
                               var desc = product.description;
                               var images = product.images;
                               var variants = product.variants;
                               var tags = product.tags;
                               $.each(tags,function(i,v) {
         if(v.indexOf('pre-order') > -1) {
        pre_order = true;
        pre_order_text = "Ships: " + v.split(':')[1];
        addText = "Pre-Order";
        $('<div class="qv-pre-order--text">'+pre_order_text+'</div>').insertBefore('.qv-add-button');
      }
    });
    var options = product.options;
    var url = '/collections/' + collection_handle + '/products/' + product_handle;
    $('.qv-product-title').html(title);
    if(color) $('.qv-product-color').text(color);
    //$('.qv-product-description').html(desc);
    $('.view-product').attr('href', url);
    var imageCount = $(images).length;
    $(images).each(function(i, image){
      if(i == imageCount - 1){
        image_embed = '<div><img data-full="https:'+image+'" src="' + image + '" alt="'+image.alt+'"></div>';
        image_embed = image_embed.replace('.jpg','_800x.jpg').replace('.png','_800x.png');
        $('#qv-product-images').append(image_embed);
        $('#qv-product-images').slick({
          dots: true,
          infinite: false,
          arrows: true,
          speed:300,
          useTransform: true,
          prevArrow: '<button type="button" class="slick-prev">'+prevArrowSVG+'</button>',
          nextArrow: '<button type="button" class="slick-next">'+nextArrowSVG+'</button>'
        }).css('opacity','1');
      } else {
        image_embed = '<div><img src="' + image + '"></div>';
        image_embed = image_embed.replace('.jpg','_800x.jpg').replace('.png','_800x.png');
        $('#qv-product-images').append(image_embed);
      }
    });


    //$('.qv-mobile-product-image').append('<img src="'+images[0].replace('.jpg','_100x.jpg')+'" />');
    $(options).each(function(i, option){
      var name = option.name;
      var opt = name.replace(/ /g, '-').toLowerCase();
      var selectClass = '.option.' + opt;
      var selectClass = '.swatch.' + opt;
      var myIndex = i; 
      if(theme.dev.variantSelection == 'swatch') {
        $('.qv-product-options').append('<div class="swatch '+opt+' clearfix" data-option-index="'+myIndex+'"><div class="header">'+option.name+': <span class="selected">Select '+option.name+'</div></div>');
      } else {
        $('.qv-product-options').append('<div class="qv-product-select"><label>'+option.name+'</label><select class="option '+opt+' clearfix"></select></div>');
      }
      $('.qv-product-options').append('<div class="selector-wrapper js product-form__item" style="display: block;"><label for="SingleOptionSelector-'+myIndex+'">'+option.name+'</label><select class="single-option-selector single-option-selector-product-template product-form__input" id="SingleOptionSelector-'+myIndex+'" data-index="option'+myIndex+'"></select></div>');

      function swatchColor(value) {
        var background = false;
        if(option.name == "Color") {
          var myColor = null;
          $.each(allColors,function(i,v) {
            if(v[0] == value) {
              //console.log(v[1]);
              myColor = v[1];
              background = 'style="font-size:1px;background:'+myColor +';color:'+myColor+'"';

            }
          });
        }
        return background;
      }

      $(option.values).each(function(i, value){
        if(option.name == 'Color') {
          // console.log('something');
        }
        var valueHandle = value.replace(/ /g, '-').toLowerCase();
        if(theme.dev.variantSelection == 'swatch') {
          var theSwatch = $('<div data-value="'+value+'" class="swatch-element '+value+' available"><input id="swatch-'+i+'-'+valueHandle+'" type="radio" name="option-'+myIndex+'" value="'+value+'"/><label for="swatch-'+i+'-'+valueHandle+'" ' + swatchColor(value) +'>'+value+'<img class="crossed-out" src="//readyrocker.com/cdn/shop/t/139/assets/sold-out.svg?v=50227261908156921341792527953"></label></div>');
                            $('.qv-product-options .swatch.' + opt).append(theSwatch);
        } else {
          $('.option.' + opt).append($('<option>', {
            value: value,
            text: value
          }));
        }

        $('.qv-product-options #SingleOptionSelector-'+myIndex).append($('<option>', {value: value,text: value})).parent().hide();
      });
    });

    $(product.variants).each(function(i, v){
      $('#quick-view--ProductSelect-product-template').append('<option value="'+v.id+'">'+v.title+'</option>').hide();
    });





    $(product.variants).each(function(i, v){
      if(v.inventory_quantity == 0){
        return true
      } else {
        price = parseInt(v.price/100).toFixed(2);
        original_price = parseInt(v.compare_at_price/100).toFixed(2);
        $('.qv-product-price').text('$' + price);
        if(original_price > 0){
          $('.qv-product-original-price').text('$' + original_price).show();
        } else {
          $('.qv-product-original-price').hide();
        }
        if(i==0)
          $('select.option-0').val(v.option1);
        if(i==1)
          $('select.option-1').val(v.option2);
        if(i==2)          
          $('select.option-2').val(v.option3);
        return false
      }
    });
    //slate.Variants();
    //theme.Product();

    var $addToCartFormQV = $('#qv-product-form');
    //Shopify.optionsMap = {};
    Shopify.linkOptionSelectors(product);
    if (window.MutationObserver && $addToCartFormQV.length) {
      if (typeof observerQV === 'object' && typeof observerQV.disconnect === 'function') {
        observerQV.disconnect();
      }
      var config = { childList: true, subtree: true };
      var observerQV = new MutationObserver(function() {      
        observerQV.disconnect();
      });  
      observerQV.observe($addToCartFormQV[0], config);
    }

    if(myColor != false ) {
      $('.qv-product-options .swatch-element input[value="'+myColor+'"]').trigger('click');
    }


  });


  $(document).on("change", "#quick-view .swatch input", function(){
    $('.qv-add-to-cart-response').html('').removeClass('success').removeClass('error');
    var selectedOptions = '';
    $('#quick-view .swatch input:checked').each(function(i){
      if(selectedOptions == ''){
        selectedOptions = $(this).val();
      } else {
        selectedOptions = selectedOptions + ' / ' + $(this).val();
      }
      $(this).closest('.swatch').find('.header .selected').text($(this).parent().data('value'));

    });
    var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
    var optionValue = jQuery(this).val();
    $(this)
    .closest('.qv-add-to-cart')
    .find('.single-option-selector')
    .eq(optionIndex)
    .val(optionValue)
    .trigger('change');



    //$('.qv-add-to-cart-response').hide();
    jQuery.getJSON('/products/' + product_handle + '.js', function(product) {
      $(product.variants).each(function(i, v) {
        if(v.title == selectedOptions){
          var price = parseInt(v.price/100).toFixed(2);
          var original_price = parseInt(v.compare_at_price/100).toFixed(2);
          var v_qty = v.inventory_quantity;
          var v_inv = v.inventory_management;
          $('.qv-product-price').text('$' + price);
          $('.qv-product-original-price').text('$' + original_price);
          if(v_inv == null){
            $('.qv-add-button').prop('disabled', false).val(addText);
          } else {
            if(v.inventory_quantity < 1){
              $('.qv-add-button').prop('disabled', true).val('Sold Out');
            } else {
              $('.qv-add-button').prop('disabled', false).val(addText);
            }
          }

          if(v.featured_image && v.featured_image.alt ) {
            //var variantImageAlt = '.filter-'+v.featured_image.alt.replace('-','').replace(/\s+/g, '-').toLowerCase() || {};
            var variantImage = v.featured_image.src;
            var colorIndex = false;


            $('#qv-product-images img').each(function(i,v) {
              if($(this).data('full') == variantImage) {
                colorIndex = $(this).parent().data('slick-index');
              } else {
                //console.log('no matches');
              }
            });
            var slider = $('#qv-product-images');
            //var colorIndex = $('#qv-product-images img[data-full="'+variantImage+'"').first().parent().data('slick-index');
            //console.log($('#qv-product-images img[data-full="'+variantImage+'"').eq(0).parent().attr('class'));
            $('#qv-product-images').slick('slickGoTo',colorIndex);
            //$('#qv-product-images').slick('slickUnfilter');
            //$('#qv-product-images').slick('slickFilter',variantImageAlt);

          }
        }
      });
    });
  });


  $(document).on("change", "#quick-view select", function(){
    $('.qv-add-to-cart-response').html('').removeClass('success').removeClass('error');
    var selectedOptions = '';
    $('#quick-view select').each(function(i){
      if(selectedOptions == ''){
        selectedOptions = $(this).val();
      } else {
        selectedOptions = selectedOptions + ' / ' + $(this).val();
      }
      //console.log('quick view select ' + selectedOptions);
    });
    jQuery.getJSON('/products/' + product_handle + '.js', function(product) {
      $(product.variants).each(function(i, v) {
        if(v.title == selectedOptions){
          var price = parseInt(v.price/100).toFixed(2);
          var original_price = parseInt(v.compare_at_price/100).toFixed(2);
          var v_qty = v.inventory_quantity;
          var v_inv = v.inventory_management;
          $('.qv-product-price').text('$' + price);
          $('.qv-product-original-price').text('$' + original_price);
          if(v_inv == null){
            $('.qv-add-button').prop('disabled', false).val(addText);
          } else {
            if(v.inventory_quantity < 1){
              $('.qv-add-button').prop('disabled', true).val('Sold Out');
            } else {
              $('.qv-add-button').prop('disabled', false).val(addText);
            }
          }
        }
      });
    });
  });


  $.magnificPopup.open({
    items: {
      src: '#quick-view'
    },
    removalDelay: 500,
    showCloseBtn: true,
    closeBtnInside: true,
    mainClass: 'mfp-with-zoom',
    type: 'inline',
    midClick: true,
    callbacks: {
      beforeOpen: function(item) {

        $(document).on('click','.mfp-close',function(e) {
          $.magnificPopup.close();
          theme.RightDrawer.open();
        });
        var product_handle = $('#quick-view').attr('class');

        $(document).on("click", ".qv-add-button", function(){      

          var qty = $('.qv-quantity').val();
          var selectedOptions = '';
          var var_id = '';
          var allOptionsSelected = false;
          var totalOptions;
          if(theme.dev.variantSelection == 'dropdown') {
            //totalOptions = $('.qu-product-options'
            $('.qv-product-options select').each(function(i){
              if(selectedOptions == ''){
                selectedOptions = $(this).val();
              } else {
                selectedOptions = selectedOptions + ' / ' + $(this).val();
              }
            });
          } else {
            totalOptions = $('#quick-view .swatch').length;
            //console.log(totalOptions);
            $('#quick-view input:checked').each(function(i) {
              if(selectedOptions == ''){
                selectedOptions = $(this).val();
              } else {
                selectedOptions = selectedOptions + ' / ' + $(this).val();
              }
            });
          }
          jQuery.getJSON('/products/' + product_handle + '.js', function(product) {
            $(product.variants).each(function(i, v) {
              //console.log(v.title + ' | selected: '+selectedOptions);
              if(v.title == selectedOptions){
                var_id = v.id;
                processCart();
              }
            });
          });
          function processCart(){
            jQuery.post('/cart/add.js', {
              quantity: qty,
              id: var_id
            },
                        null,
                        "json"
                       ).done(function(a,b,c) {
              //console.log(a);
              if(closePopupOpenDrawer) {
                theme.addToCartOk();
              } else {
                $('.qv-add-to-cart-response').addClass('success').html('<span>' + $('.qv-product-title').text() + ' has been added to your cart. <a href="/cart">View Cart</a> or <a href="#" class="qv-continue-shopping">Continue Shopping</a>');
              }
            })
            .fail(function($xhr) {
              var data = $xhr.responseJSON;
              $('.qv-add-to-cart-response').addClass('error').html('<span><b>ERROR: </b>' + data.description);
            });
          }

        });
        $('.fancybox-wrap').css('overflow','hidden !important');
      },
      open: function() {
        //$('body').addClass('blur');
        $('#quick-view').hide().html(content).css('opacity','1').fadeIn(function(){
          $('#qv-product-images').addClass('loaded');
        });
      },
      beforeClose: function() {
        $('body').removeClass('blur');
      },
      afterClose: function() {
        $('#quick-view').removeClass().empty();
      }

    }
  },0);
});  
};

theme.afterCartLoad = function () {
  theme.cache.$cartContainer.on('ajaxCart.afterCartLoad', function(evt, cart) {
    //theme.RightDrawer.open();

    // set cart bubble after ajax cart update
    if (cart.item_count > 0) {
      theme.cache.$siteHeaderCart.addClass('cart-bubble--visible');
    } else {
      theme.cache.$siteHeaderCart.removeClass('cart-bubble--visible');
    }

    // Size the cart's fixed footer
    theme.sizeCartDrawerFooter();
  });

  theme.cache.$cartContainer.on('ajaxCart.updatingQty', function() {
    $('.cart__checkout').addClass('btn--ajax-disabled');
  });
};

theme.init = function() {
  // console.log('theme.init');
  theme.removeCookies();
  theme.customerTemplates.init();
  theme.drawersInit();
  //theme.quickView();
  theme.windowScrolling();
  theme.cookiesPopup();
  if($('body').hasClass('template-search')) {
    theme.SearchFilters();
  }
  theme.PressPage();

  theme.itsSelectric();

  // Theme-specific selectors to make tables scrollable
  var tableSelectors = '.rte table,' + '.custom__item-inner--html table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'scrollable-wrapper'
  });

  var config = {
    mediaQuerySmall: 'screen and (max-width: 749px)',
    mediaQueryMediumUp: 'screen and (min-width: 750px)',
    slideCount: 0
  };

  // Theme-specific selectors to make iframes responsive
  var iframeSelectors =
      '.rte iframe[src*="youtube.com/embed"],' +
      '.rte iframe[src*="player.vimeo"],' +
      '.custom__item-inner--html iframe[src*="youtube.com/embed"],' +
      '.custom__item-inner--html iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'video-wrapper'
  });

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  $('a[href="#"]').on('click', function(evt) {
    evt.preventDefault();
  });

  slate.a11y.accessibleLinks({
    messages: {
      newWindow: theme.strings.newWindow,
      external: theme.strings.external,
      newWindowExternal: theme.strings.newWindowExternal
    },
    $links: $('a:not([aria-describedby], .product-single__thumbnail)')
  });

  $('.drawer-nav__has-sublist .drawer-nav__link').on('click',function(e) {
    e.preventDefault();
    $(this).parent().toggleClass('drawer-nav--expanded');
  });


  enquire.register(config.mediaQuerySmall, {
    match: function() {
      //initSlider($slider, mobileOptions);

      $('.mobile-accordion').on('click',function(e) {
        e.preventDefault();
        $(this).toggleClass('show').next().slideToggle();
      });
    }
  });

  enquire.register(config.mediaQueryMediumUp, {
    match: function() {
      theme.productHovers();
    }
  });

  $(document).on('click','.has-sub',function(e) {
    e.preventDefault();
    $(this).toggleClass('active').next().slideToggle();
  });

  $('.btn--update-cart-note').on('click',function(e) {
    e.preventDefault();
    var form = $(this).closest('form');
    if($('.ajaxcart__gift-note--textarea').val() != '') {
      var newVal = $('.ajaxcart__gift-note--textarea').val();    
      $.ajax({
        url: '/cart/update.js',
        type: 'post',
        data: {note: newVal},
        success: function(result) { 
          form.submit();
        },
        error: function(jqxhr, status, exception) {
        }
      });
    }
  });
  if($('#index-reviews-slider').length) {
    $.get('/products/new-ready-rocker',function(data) {
      $('#index-reviews-slider').html($(data).find('.reviews-slider__wrapper').html());
      $('.reviews-slider').slick({
        dots: false,
        arrows: true,
        infinite: true,
        prevArrow: '<button type="button" class="slick-prev">'+prevArrowSVG+'</button>',
        nextArrow: '<button type="button" class="slick-next">'+nextArrowSVG+'</button>',
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: 1,
        adaptiveHeight: false
      });
    });

  }
  $('.hero-slideshow').each(function() {
    $(this).slick({
      dots: true,
      arrows: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: 1,
      adaptiveHeight: true
    });
  });

};

$(theme.init);




/*============================================================================
  Override POST to cart/add.js. Returns cart JSON.
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
Shopify.addItemFromForm = function(form, callback, errorCallback) {
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      }
      else {
        theme.addToCartOk();
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        theme.onError(XMLHttpRequest, textStatus);
      }
    }
  };
  jQuery.ajax(params);
};

theme.updateCartFromForm = function(e, t) {
  var n = {
    type: "POST",
    url: "/cart/update.js",
    data: jQuery("#" + e).serialize(),
    dataType: "json",
    success: function(e) {
      "function" == typeof t ? t(e) : theme.updateCartPage(e)

      if (window.affirm && window.affirm.ui && typeof window.affirm.ui.refresh === "function") { window.affirm.ui.refresh(); }
    },
    error: function(e, t) {
      theme.onError(e, t)
    }
  };
  $.ajax(n)
};

theme.onError = function() {
};

theme.showSideCartLoader = function() {
  $('.inline-cart--loading').fadeIn();

  if (window.affirm && window.affirm.ui && typeof window.affirm.ui.refresh === "function") { window.affirm.ui.refresh(); }
};
theme.hideSideCartLoader = function() {
  $('.inline-cart--loading').fadeOut();

  if (window.affirm && window.affirm.ui && typeof window.affirm.ui.refresh === "function") { window.affirm.ui.refresh(); }
};
// AJAX cart

theme.removeItem = function(id) {
  //console.log('remove item: '+id);
  $.post('/cart/change.js',{
    quantity: 0,
    id: id,
    success: theme.onCartUpdate,
    error: theme.updateCartFail
  });
};
theme.removeSideCartItem = function(t,r) {
  var e = {
    type: "POST",
    url: "/cart/change.js",
    data: "quantity=0&id=" + t,
    dataType: "json",
    success: function(t) {
      "function" == typeof r ? r(t) : theme.onCartUpdate(t)

      if (window.affirm && window.affirm.ui && typeof window.affirm.ui.refresh === "function") { window.affirm.ui.refresh(); }
    },
    error: function(t, r) {
      theme.onError(t, r)
    }
  };
  jQuery.ajax(e)
};

theme.updateItem = function(t,r,e) {
  theme.showSideCartLoader();
  var a = {
    type: "POST",
    url: "/cart/change.js",
    data: "quantity=" + r + "&id=" + t,
    dataType: "json",
    success: function(t) {
      "function" == typeof e ? e(t) : theme.onCartUpdate(t)

      if (window.affirm && window.affirm.ui && typeof window.affirm.ui.refresh === "function") { window.affirm.ui.refresh(); }
    },
    error: function(t, r) {
      theme.onError(t, r);
    }
  };
  jQuery.ajax(a);
};

theme.onCartUpdate = function(e) {
  $.get('/cart', function(t) {
    $('.inline-cart--container').html($(t).find('.inline-cart--container').html());
    $('.site-header__cart').html($(t).find('.site-header__cart').html());
  }).done(function() {
    theme.hideSideCartLoader();

    if (window.affirm && window.affirm.ui && typeof window.affirm.ui.refresh === "function") { window.affirm.ui.refresh(); }
  });;
};
theme.addItemFromForm = function(form_id) {
  $.ajax({
    type: 'POST', 
    url: '/cart/add.js',
    dataType: 'json', 
    data: $('#'+form_id).serialize(),
    success: theme.addToCartOk,
    error: theme.addToCartFail
  });
};
theme.addItem = function(t, r, e) {
  var r = r || 1,
      a = {
        type: "POST",
        url: "/cart/add.js",
        data: "quantity=" + r + "&id=" + t,
        dataType: "json",
        success: function(t) {
          "function" == typeof e ? e(t) : theme.addToCartOk(t)

          if (window.affirm && window.affirm.ui && typeof window.affirm.ui.refresh === "function") { window.affirm.ui.refresh(); }
        },
        error: function(t, r) {
          c.onError(t, r)
        }
      };
  jQuery.ajax(a);
};

theme.addToCartOk = function(product) {
  ///cart?view=inline-cart-contents
  //console.log(product);

  var upsell = true;
  $.magnificPopup.close();

  $.get( "/cart?view=inline-cart-contents", function(t) {
    $('.inline-cart--container').html(t);
    $('.site-header__cart').html($(t).find('.site-header__cart').html());

    if (window.affirm && window.affirm.ui && typeof window.affirm.ui.refresh === "function") { window.affirm.ui.refresh(); }

  }).done(function() {
    $('.btn--small-add').addClass('ready-to-add').text(addToCart);
                $(".upsell-wrap .slick-prev").trigger('click');
    if(preOrder) {
      $('#AddToCart-product-template').find('#AddToCartText-product-template').text(addToCart).parent().addClass('ready-to-add');
      //       console.log(preOrderText+'nownow');
    } else {
      $('#AddToCart-product-template').find('#AddToCartText-product-template').text(addToCart).parent().addClass('ready-to-add');
    }
   
    if(upsell && product.product_type == 'Portable Rocking Chair' && $('#upsell-popup').length) {
      var Check__upsell = $('.Noupsell_bundle_product_type').attr('data-noupsell');

      if (Check__upsell == null){

        $.magnificPopup.open({
          items: {
            src: '#upsell-popup', // can be a HTML string, jQuery object, or CSS selector
            type: 'inline'
          },
          removalDelay: 300,
          mainClass: 'mfp-with-zoom',
          callbacks: {
            close: function(){

              theme.RightDrawer.open();
            }
          }
        });
        function getSliderSettings() {
          return {
              slidesToShow: 3,
              slidesToScroll:3,
              arrows:true,
              adaptiveHeight: true,
              infinite: false,
              responsive: [
              {
                breakpoint: 779,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll:1,
                  arrows:true,
                  fade: true,
                  speed: 1000,
                  infinite: false,
                  cssEase: 'ease-in-out'
                }
              }
            ]

          }
        }
        $('#upsell-popup').on('mfpOpen', function(e) {
          $('html').addClass('expertpopupopen').css('overflow','hidden');
          $('body').css('overflow','hidden');


        });

        $('#upsell-popup').on('mfpClose', function(e) {

          $('html').removeClass('expertpopupopen').css('overflow','unset');
          $('body').css('overflow','unset');

        });
          $('#upsell-popup .upsell-wrap').not('.slick-initialized').slick(getSliderSettings());
          $(".upsell-wrap").slick('setPosition');

      }
      else{
        if(Check__upsell == 'true'){

          theme.RightDrawer.open();

          if (window.affirm && window.affirm.ui && typeof window.affirm.ui.refresh === "function") { window.affirm.ui.refresh(); }



        }
        else{
          $.magnificPopup.open({
            items: {
              src: '#upsell-popup', // can be a HTML string, jQuery object, or CSS selector
              type: 'inline'
            },
            removalDelay: 300,
            mainClass: 'mfp-with-zoom',
            callbacks: {
              close: function(){

                theme.RightDrawer.open();
              }
            }
          });
          function getSliderSettings() {
            return {
              responsive: [
                {
                  breakpoint: 779,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll:1,
                    arrows:true,
                    fade: true,
                    speed: 1000,
                    infinite: true,
                    cssEase: 'ease-in-out'
                  }
                }
              ]

            }
          }
          $('#upsell-popup').on('mfpOpen', function(e) {
            $('html').addClass('expertpopupopen').css('overflow','hidden');
            $('body').css('overflow','hidden');


          });

          $('#upsell-popup').on('mfpClose', function(e) {

            $('html').removeClass('expertpopupopen').css('overflow','unset');
            $('body').css('overflow','unset');

          });
          if($(window).width() <= 779){
            $('#upsell-popup .upsell-wrap').not('.slick-initialized').slick(getSliderSettings());
            $(".upsell-wrap").slick('setPosition');

          }



        }
      }

    }

    else {

      theme.RightDrawer.open();

      if (window.affirm && window.affirm.ui && typeof window.affirm.ui.refresh === "function") { window.affirm.ui.refresh(); }
    }
  });
};


theme.addToCartFail = function(obj, status) { 
  $('.cart-preloader').fadeOut();
};

theme.updateCartPage = function (cart) {
  $.get( "/cart", function( data ) {
    $('#cart-page--inner').html($(data).find('#cart-page--inner').html());
    $('#CartContainer').html($(data).find('#CartContainer').html());
    $('.cart-count-number').text($(data).find('.site-header__cart .cart-count-number').text());
    //console.log('Cart Should have updated');
  }).always(function() {
    $('.cart-preloader').fadeOut();
    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
  });
};





$(window).resize(function(){
  if($('#quick-view').is(':visible')){
    $('.qv-product-images').slick();
    //theme.HeaderSection();
  }
});


$(function() {
  var newPink = '#BF6F88'; 

  $('[fill="#e9b1c3"]').each(function() {
    var $this = $(this).attr('fill',newPink);
  });

  /*$.magnificPopup.open({
    items: {
      src: '#upsell-popup', // can be a HTML string, jQuery object, or CSS selector
      type: 'inline'
    }
  });
  */

  $('.upsell-popup-close').on('click',function(e) {
    e.preventDefault();
   $.magnificPopup.close();
    theme.RightDrawer.open();

    if (window.affirm && window.affirm.ui && typeof window.affirm.ui.refresh === "function") { window.affirm.ui.refresh(); }

  // var get_check = $(".upsell-wrap .slick-next").attr('aria-disabled');
  //   if(get_check == "true"){
  //   $.magnificPopup.close();
  //   theme.RightDrawer.open();

  //   _affirm_config = {
  //     public_api_key:  "L6ACPMTZ6583AU3Y",
  //     script:          "https://cdn1.affirm.com/js/v2/affirm.js"
  //   };
  //   (function(l,g,m,e,a,f,b){var d,c=l[m]||{},h=document.createElement(f),n=document.getElementsByTagName(f)[0],k=function(a,b,c){return function(){a[b]._.push([c,arguments])}};c[e]=k(c,e,"set");d=c[e];c[a]={};c[a]._=[];d._=[];c[a][b]=k(c,a,b);a=0;for(b="set add save post open empty reset on off trigger ready setProduct".split(" ");a<b.length;a++)d[b[a]]=k(c,e,b[a]);a=0;for(b=["get","token","url","items"];a<b.length;a++)d[b[a]]=function(){};h.async=!0;h.src=g[f];n.parentNode.insertBefore(h,n);delete g[f];d(g);l[m]=c})(window,_affirm_config,"affirm","checkout","ui","script","ready");
  //     }else{
  //   $(".upsell-wrap .slick-next").trigger('click');
  //     }

   });
  $(document).on('click','.upsell-add-btn, .accessories-add-btn, .pre-order-now-btn',function(e){
    //   $('.upsell-add-btn, .accessories-add-btn, .pre-order-now-btn').on('click',function(e) {

    e.preventDefault();

    var myVariant = $(this).data('variant-id');
    theme.addItem(myVariant);

    if (window.affirm && window.affirm.ui && typeof window.affirm.ui.refresh === "function") { window.affirm.ui.refresh(); }
  });

  $("h1,h2,h3,h4").each(function(){
    $(this).html($(this).html().replace(/&trade;/gi, '<sup>&trade;</sup>').replace(/™/gi, '<sup>&trade;</sup>'));
    //.replace('<sup><sup>', '<sup>').replace('</sup></sup>', '</sup>'));
  });

  $('a')
  .filter('[href^="http"], [href^="//"]')
  .not('[href*="' + window.location.host + '"]')
  .attr('rel', 'noopener noreferrer')
  .attr('target', '_blank');

  //$('™').wrapAll('<span class="trademark" />');
  $('.fitvids').fitVids();
  /*
  $('.mfp-iframe').magnificPopup({
    type:'iframe',
    removalDelay: 300,
    mainClass: 'mfp-with-zoom'
  });
  */
  $(document).on('click','.mfp-iframe',function(e) {
    e.preventDefault();
    var $this = $(this);
    $.magnificPopup.open({
      items: {
        src: $this.attr('href'),
        type: 'iframe'
      }

    }, 0);
    return false;
  });
  $('.mfp-inline').magnificPopup({
    type:'inline',
    removalDelay: 300,
    mainClass: 'mfp-with-zoom'
  });
  $('.our-partners-slick').slick({
    arrows: true,
    slidesToShow: 6,
    prevArrow: '<button type="button" class="slick-prev">'+prevArrowSVG+'</button>',
    nextArrow: '<button type="button" class="slick-next">'+nextArrowSVG+'</button>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  });
  $('.site-nav__shop-dropdown').slick({
    arrows: true,
    slidesToShow: 1,
    prevArrow: '<button type="button" class="slick-prev">'+prevArrowSVG+'</button>',
    nextArrow: '<button type="button" class="slick-next">'+nextArrowSVG+'</button>'
  });

  $(document).on('click','.qty-step-btn',function(z) {
    z.preventDefault();
    var i = parseInt($(this).siblings('.qty-step-count').text()),
        t = $(this).siblings('.qty-step-count'),
        o = $(this).data('qty-change'),
        r = $(this).closest('.qty-step'),
        e = $(this).closest('.line-item').attr('data-inventory'),
        v = $(this).closest('.line-item').attr('data-variant-id'),
        u = $(this).data('qty-change');

    if(u == 'dec') {
      i--;
    } else {
      if(i < parseInt(v)) {
        i++;
      } 
    }

    if (window.affirm && window.affirm.ui && typeof window.affirm.ui.refresh === "function") { window.affirm.ui.refresh(); }
    theme.updateItem(v, i);

  });

  function QtySubtract(obj) {
    var qtyInput = $(obj).siblings('.cart__qty-input');
    //     console.log(qtyInput.val());
    var current_value = parseInt(qtyInput.val());
    var next_value = current_value - 1;
    //     console.log(next_value);
    qtyInput.val(next_value);
    $('.cart__update').trigger('click');

    if (window.affirm && window.affirm.ui && typeof window.affirm.ui.refresh === "function") { window.affirm.ui.refresh(); }
  }
  function QtyAdd(obj) {
    var qtyInput = $(obj).siblings('.cart__qty-input');
    var current_value = parseInt(qtyInput.val());
    var next_value = current_value;
    if(current_value < 9) {
      var next_value = current_value + 1;
    }
    qtyInput.val(next_value);
    $('.cart__update').trigger('click');

    if (window.affirm && window.affirm.ui && typeof window.affirm.ui.refresh === "function") { window.affirm.ui.refresh(); }
  }

  $(document).on('click','.qty-change', function(e) {
    e.preventDefault();
    $('.cart-preloader').fadeIn();
    if($(this).hasClass('qty-minus')) {
      QtySubtract($(this));
    } else {
      QtyAdd($(this));
    }      

    if (window.affirm && window.affirm.ui && typeof window.affirm.ui.refresh === "function") { window.affirm.ui.refresh(); }
  });

  $(document).on('click','.line-item--remove-btn',function(e) {
    theme.showSideCartLoader();
    e.preventDefault();
    var i = $(this).attr('data-edit-item');
    //$(this).closest('.line-item').fadeOut();
    theme.removeSideCartItem(i);

    if (window.affirm && window.affirm.ui && typeof window.affirm.ui.refresh === "function") { window.affirm.ui.refresh(); }
  });
  if(theme.isMobile()) {
    $('.responsive-table tbody tr td:not(.small--hide):even').addClass('table--light-grey-bg');

    if (window.affirm && window.affirm.ui && typeof window.affirm.ui.refresh === "function") { window.affirm.ui.refresh(); }
  }


  $('.message-from-milena--link').on('click',function(e) {
    e.preventDefault();
    var messageBox = $('#message-from-milena');
    messageBox.toggleClass('opened');
    $('.message-from-milena--wrapper').toggleClass('opened');

  });
  $('.message-from-milena--close').on('click',function(e) {
    e.preventDefault();
    var messageBox = $('#message-from-milena');
    messageBox.toggleClass('opened');
    $('.message-from-milena--wrapper').toggleClass('opened');
  });

  $('.quick-add').on('click',function() {
    var myVariant = $(this).data('variant-id');
    theme.addItem(myVariant);
    return false;
  });

  /*
  $('.floater--chat,.open-fc-widget').on('click',function(e) {
    e.preventDefault();
    $('#fc_frame').show();
    window.fcWidget.open();
  });
  */

  if(window.location.href.indexOf('/pages/how-it-works') > 1 || window.location.href.indexOf('/pages/shipping') > 1) {
    $.get('/',function(data) {
      var newContent = $(data).find('#shopify-section-featured-collections').html();
      $('.get-rockin').html(newContent);
      $('.featured-collection').slick({
        infinite: true,
        prevArrow: prevArrowSVG,
        nextArrow: nextArrowSVG,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              dots: true
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          }
        ]
      });
    });
  }

  $.fn.addRegMark = function(src){
    var re = new RegExp("("+src+")","ig");
    return this.each(function(){
      $(this).contents().filter(function(){
        return this.nodeType != 1;
      }).each(function(){
        var output = $(this).text().replace(re,"<sup>&reg;</sup>");
        if (output != $(this).text()) {
          $(this).wrap("<p />").parent().html(output).contents().unwrap();
        }
      });
    });
  };
  $("h2, p").addRegMark("ACRONYM");

  function draw_image(url) {
    var ctx = document.getElementById('canvas_0').getContext('2d');
    var img = new Image();
    img.addEventListener('load', function(){
      ctx.drawImage(img, 0, 0);
    });
    img.src = url;
  }

  var images_set_0 = [
    "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15ROCKING00_600x.jpg",
    "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15ROCKING01_600x.jpg",
    "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15ROCKING02_600x.jpg",
    "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15ROCKING03_600x.jpg",
    "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15ROCKING04_600x.jpg",
    "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15ROCKING05_600x.jpg",
    "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15ROCKING06_600x.jpg",
    "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15ROCKING07_600x.jpg",
    "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15ROCKING08_600x.jpg",
    "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15ROCKING09_600x.jpg",
    "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15ROCKING10_600x.jpg",
    "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15ROCKING11_600x.jpg",
    "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15ROCKING12_600x.jpg",
    "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15ROCKING13_600x.jpg",
    "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15ROCKING14_600x.jpg",
    "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15ROCKING15_600x.jpg",
    "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15ROCKING16_600x.jpg",
    "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15ROCKING17_600x.jpg",
    "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15ROCKING18_600x.jpg",
    "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15ROCKING19_600x.jpg"  
  ];

  if (document.getElementById('canvas_0')) {
    draw_image(images_set_0[0]);
  }
  $("#startAnimate").click( function(){

    // TweenMax can tween any property of any object. We use this object to cycle through the array
    var obj_0 = {curImg: 0};

    // create tween
    var tween_0 = TweenMax.to(obj_0, 0.5,
                              {
      curImg: images_set_0.length - 1,	// animate propery curImg to number of images
      roundProps: "curImg",				// only integers so it can be used as an array index
      repeat: 0,									// repeat 3 times
      immediateRender: true,			// load first image automatically
      ease: Linear.easeNone,			// show every image the same ammount of time
      onUpdate: function () {
        // $("#imgsequence").attr("src", images_set_1[obj_1.curImg]); // set the image source
        draw_image(images_set_0[obj_0.curImg]);
      }
    });

  });


  function draw_animation_1(url) {
    var ctx = document.getElementById('canvas_1').getContext('2d');
    var img = new Image();
    img.addEventListener('load', function(){
      ctx.drawImage(img, 0, 0);
    });
    img.src = url;
  }

  function draw_animation_2(url) {
    var ctx = document.getElementById('canvas_2').getContext('2d');
    var img = new Image();
    img.addEventListener('load', function(){
      ctx.drawImage(img, 0, 0);
    });
    img.src = url;
  }

  function computeSceneOffset(parentPin) {
    var offset = $(parentPin).find('.feature-row__text').outerHeight();
    return (window.innerWidth > 780) ? 50 : offset - 180;
  }
  if($('#ImageSequence').length > 0) {
    // define images
    var images_set_1 = [
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/JPG01_600x.jpg",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/JPG02_600x.jpg",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/JPG03_600x.jpg",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/JPG04_600x.jpg",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/JPG05_600x.jpg",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/JPG06_600x.jpg",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/JPG07_600x.jpg",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/JPG08_600x.jpg",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/JPG09_600x.jpg",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/JPG10_600x.jpg",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/JPG11_600x.jpg",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/JPG12_600x.jpg",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/JPG13_600x.jpg",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/JPG14_600x.jpg",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/JPG15_600x.jpg",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/JPG16_600x.jpg",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/JPG17_600x.jpg",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/JPG18_600x.jpg",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/JPG19_600x.jpg",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/JPG20_600x.jpg",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/JPG21_600x.jpg",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/JPG22_600x.jpg",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/JPG23_600x.jpg",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/JPG24_600x.jpg",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/JPG25_600x.jpg",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/JPG26_600x.jpg",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/JPG27_600x.jpg",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/JPG28_600x.jpg",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/JPG29_600x.jpg",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/JPG30_600x.jpg",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/JPG31_600x.jpg",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/JPG32_600x.jpg",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/JPG33_600x.jpg",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/JPG34_600x.jpg",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/JPG35_600x.jpg",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/JPG36_600x.jpg",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/JPG37_600x.jpg",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/JPG38_600x.jpg",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/JPG39_600x.jpg",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/JPG40_600x.jpg",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/JPG41_600x.jpg",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/JPG42_600x.jpg",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/JPG43_600x.jpg",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/JPG44_600x.jpg",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/JPG45_600x.jpg",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/JPG46_600x.jpg",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/JPG47_600x.jpg"
    ];

    // TweenMax can tween any property of any object. We use this object to cycle through the array
    var obj_1 = {curImg: 0};
    var pin1 = "#pin1";
    var offset1 = computeSceneOffset(pin1);

    // create tween
    var tween_1 = TweenMax.to(obj_1, 0.5,
                              {
      curImg: images_set_1.length - 1,	// animate propery curImg to number of images
      roundProps: "curImg",				// only integers so it can be used as an array index
      repeat: 0,									// repeat 3 times
      immediateRender: true,			// load first image automatically
      ease: Linear.easeNone,			// show every image the same ammount of time
      onUpdate: function () {
        // $("#imgsequence").attr("src", images_set_1[obj_1.curImg]); // set the image source


        draw_animation_1(images_set_1[obj_1.curImg]);
      }
    });
    // init controller
    var controller_1 = new ScrollMagic.Controller();

    // build scene
    var scene_1 = new ScrollMagic.Scene({
      triggerElement: "#trigger1", 
      triggerHook: 0.25,
      duration: 500,
      offset: offset1
    })

    .setTween(tween_1)
    .setPin(pin1)
    //     .on("change update progress start end enter leave", AnimationEvent1)
    // .addIndicators() // add indicators (requires plugin)
    .addTo(controller_1);
  }

  if($('#ImageSequenceExploded').length > 0) {
    /* LET OP: 
    voeg : https://cdnjs.cloudflare.com/ajax/libs/ScrollMagic/2.0.0/plugins/animation.gsap.js toe
    gebruik : 	var scene = new ScrollMagic.Scene
    */

    // define images
    var images_set_2 = [
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED000_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED001_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED002_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED003_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED004_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED005_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED006_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED007_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED008_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED009_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED010_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED011_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED012_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED013_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED014_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED016_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED017_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED018_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED019_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED020_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED021_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED022_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED023_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED024_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED025_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED026_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED027_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED028_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED029_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED030_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED031_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED032_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED033_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED034_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED035_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED036_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED037_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED038_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED039_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED040_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED041_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED042_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED043_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED044_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED045_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED046_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED047_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED048_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED049_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED050_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED051_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED052_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED053_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED054_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED055_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED056_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED057_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED058_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED059_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED060_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED061_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED062_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED063_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED064_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED065_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED066_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED067_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED069_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED070_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED071_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED072_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED073_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED074_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED075_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED076_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED077_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED078_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED079_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED080_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED081_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED082_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED083_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED084_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED085_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED086_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED087_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED088_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED089_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED090_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED091_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED092_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED093_600x.jpg?v=1604428926",
      "https://cdn.shopify.com/s/files/1/0088/1750/8410/files/15FRAMEEXPLODED094_600x.jpg?v=1604428926"
    ];

    // TweenMax can tween any property of any object. We use this object to cycle through the array
    var obj_new = {curImg: 0};
    var pin2 = "#pin2";
    var offset2 = computeSceneOffset(pin2);

    // create tween
    var tween_new = TweenMax.to(obj_new, 0.5,
                                {
      curImg: images_set_2.length - 1,	// animate propery curImg to number of images
      roundProps: "curImg",				// only integers so it can be used as an array index
      repeat: 0,									// repeat 3 times
      immediateRender: true,			// load first image automatically
      ease: Linear.easeNone,			// show every image the same ammount of time
      onUpdate: function () {
        // $("#imgsequenceexploded").attr("src", images_set_2[obj_new.curImg]); // set the image source
        draw_animation_2(images_set_2[obj_new.curImg]);
      }
    }
                               );
    // init controller
    var controllernew = new ScrollMagic.Controller();

    // build scene
    var scene = new ScrollMagic.Scene({
      triggerElement: "#trigger2", 
      triggerHook: 0.25,
      duration: 1000,
      offset: offset2
    })

    .setTween(tween_new)
    .setPin(pin2)
    //     .on("change update progress start end enter leave", AnimationEvent2)
    // .addIndicators() // add indicators (requires plugin)
    .addTo(controllernew);
  }
});



const debug = true;

function log(message,color) {
  if (debug) { 
    console.log('%c ' + message,'background: transparent; color: '+color);
  }
}

log('Populating dropdown with cities','#bada55'); // prints if debug is true


if(document.getElementsByClassName('template-index')) {
  // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
  let vh = window.innerHeight * 0.01;
  // Then we set the value in the --vh custom property to the root of the document
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}

$('.open_expert_popup').magnificPopup({
  type:'inline',
  midClick: true
});

$('.open_expert_popup').on('mfpOpen', function(e) {
  $('html').addClass('expertpopupopen').css('overflow','hidden');
  $('body').css('overflow','hidden');
});
$('.open_expert_popup').on('mfpClose', function(e) {
  $('html').removeClass('expertpopupopen').css('overflow','unset');
  $('body').css('overflow','unset');
});


$('.miracle_slider').slick({
  arrows: true,
  fade: true,
  speed: 1000,
  infinite: true,
  cssEase: 'ease-in-out'
});
$('.benefits_slider').slick({
  arrows: true,
  autoplay: true,
  autoplaySpeed: 3000
});


// if(!readCookie('disclaimer')){
// 	$('.disclaimer-fixed-page').removeClass('disclaimerClose');
// }

// $(document).on('click','.disclaimer-fixed-page-hide-button , .disclaimer-fixed-page a',function(e){
//   $(this).parent('.disclaimer-fixed-page').addClass('disclaimerClose');
//   createCookie('disclaimer','checked',1);
// });



// Cookies
function createCookie(name, value, days) {
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    var expires = "; expires=" + date.toGMTString();
  }
  else var expires = "";               

  document.cookie = name + "=" + value + expires + "; path=/";
}

function readCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function eraseCookie(name) {
  createCookie(name, "", -1);
}


if($('.policyCheckboxes').data('enabled')){

  $('button#AddToCart-product-template , .video-banner--cta .btn ').prop('disabled',true);

  $('.policyCheckboxes input[type=checkbox]').change(function() { 
    var uncheck = false;
    $('.policyCheckboxes input[type=checkbox]').each(function () {
      if(!this.checked){
        uncheck = true;
      }
    });

    if(uncheck){
      $('button#AddToCart-product-template , .video-banner--cta .btn ').prop('disabled',true);
    }else{
      $('button#AddToCart-product-template , .video-banner--cta .btn').prop('disabled',false);
    }
  });
}



$(document).on('click','span.announcement_close',function(e){
  $('div.announcement-bar').hide();
});

$(document).on('click','#upsell-popup button.mfp-close',function(e) {
  $.magnificPopup.close();
  theme.RightDrawer.open();
});
$('a.comparison-btn').magnificPopup({
  type: 'image'
  // other options
});

$(document).on('click','.specifications h3.tab-title',function(e) {
  e.preventDefault();
  $(this).toggleClass('open');
  $('.specifications .product-specification__wrap').slideToggle('slow');
});


$(document).on('click','.explore_btn',function(e) {
  e.preventDefault();
  $(this).toggleClass('openTab');
  $(".explore_benefits_links.mobile_only").slideToggle();
});

$(window).scroll(function(e) {
  $(".explore_benefits_links.mobile_only").slideUp();
});


window.onload = function() {
  $('body').css('opacity','1');
};

$('.rocker_colors_wrapper li').hover(function(e){
  // $(document).on('hover','.rocker_colors_wrapper li',function(e) {
  $(this).toggleClass('active');
  var title = $(this).data('title');
  $('.rocker_colors_wrapper h4.label span').text(title);
});


if($(window).width() <= 779){
  $('.slider-benefit .slide_container').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots:true,
    arrows:false
  });
}


$('.slider-testimonials-benefit .slide_container').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  variableWidth: false,
  infinite:true,
  arrows:true,
  responsive: [
    {
      breakpoint: 779,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true
      }
    }
  ]
});


$('.slider-logo-benefit .slide_container').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 779,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows:false,
        autoplay: true,
        autoplaySpeed: 3000
      }
    }
  ]
});



$.fn.isOnScreen = function() {
  var win = $(window);
  var viewport = {
    top: win.scrollTop(),
    left: win.scrollLeft()
  };
  viewport.right = viewport.left + win.width();
  viewport.bottom = viewport.top + win.height();
  var bounds = this.offset();
  if(typeof bounds != "undefined") {
    bounds.right = bounds.left + this.outerWidth();
    bounds.bottom = bounds.top + this.outerHeight();
    return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
  }
};
// $.fn.inView = function(){
//     //Window Object
//     var win = $(window);
//     //Object to Check
//     obj = $(this);
//     //the top Scroll Position in the page
//     var scrollPosition = win.scrollTop();
//     //the end of the visible area in the page, starting from the scroll position
//     var visibleArea = win.scrollTop() + win.height();
//     //the end of the object to check
//     var objEndPos = (obj.offset().top + obj.outerHeight());
//     return(visibleArea >= objEndPos && scrollPosition <= objEndPos ? true : false)
// };

  

$(document).ready(function(){
  $(".custom_main_rockers-bundle").slick('unslick');
                    if($('.rocker-thumbnails__image-wrap').length == 1){
  var get_length = $(".product_gallery_images").val();
if (typeof get_length === "undefined") {
var slides_show = 4;
    // ...
}else{
var set_slide = parseInt(get_length);
var slides_show  = get_length - 1 ;
}
$("div#custom_pro_slide").slick({
          dots: false,
          arrows: false,
          swipeToSlide: true,
          draggable:true,
          accessibility: false,
          speed: 500,
          fade: true,
          asNavFor: '.custom_main_rockers-bundle'
        });


        $('.custom_main_rockers-bundle').slick({
          arrows: true,
          slidesToShow: 4,
          slidesToScroll: 1,
          vertical: true,
          verticalScrolling: false,
          asNavFor: "div#custom_pro_slide",
          focusOnSelect: true,
          responsive: [
            {
              breakpoint: 779,
              settings: {
                arrows: true,
                slidesToScroll: 1,
                slidesToShow: 4,
                vertical: false,
                asNavFor: "div#custom_pro_slide",
                focusOnSelect: true
              }
            }
          ]
        });

        // $("div#custom_pro_slide").on("beforeChange", function (event, slick){
        //   var iframe = $('.rocker-iframe-video')[0];
        //   var player = $f(iframe);
        //   player.api('pause'); 
        // });

      }
      else if($('.newrocker-thumbnails__image-wrap').length == 1){
        $("div#custom_pro_slide").slick({
          dots: false,
          arrows: false,
          swipeToSlide: true,
          accessibility: false,
          speed: 500,
          fade: true,
          asNavFor: '.custom_main_rockers-bundle'
        });

        $('.custom_main_rockers-bundle').slick({
          arrows: true,
          slidesToShow: 4,
          slidesToScroll: 1,
          vertical: true,
          verticalScrolling: false,
          asNavFor: "div#custom_pro_slide",
          focusOnSelect: true,
          responsive: [
            {
              breakpoint: 779,
              settings: {
                arrows: true,
                slidesToScroll: 1,
                slidesToShow: 4,
                vertical: false,
                asNavFor: "div#custom_pro_slide",
                focusOnSelect: true
              }
            }
          ]
        });
      }
      else{
        $("div#custom_pro_slide").slick({
          dots: true,
          arrows: false,
          swipe: true,
          swipeToSlide: true,
          touchMove: true,
          draggable: true,
          accessibility: false
          // mobileFirst: true,
          // responsive: [
          //   {
          //     breakpoint: 1050,
          //     settings: {
          //       arrows: true
          //     }
          //   }
          // ]
          //prevArrow: '<button type="button" class="slick-prev"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><defs><style>.cls-1{fill:#231f20}</style></defs><path class="cls-1" d="M437.67 129.51a35 35 0 0 1 24.75 59.75L272.67 379l189.75 189.74a35 35 0 1 1-49.5 49.5L198.43 403.75a35 35 0 0 1 0-49.5l214.49-214.49a34.89 34.89 0 0 1 24.75-10.25z" transform="translate(-188.18 -129.51)" fill="#000000"/></svg></button>',
          //nextArrow: '<button type="button" class="slick-next"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 284.49 498.98"><defs><style>.cls-1{fill:#231f20}</style></defs><path class="cls-1" d="M223.18 628.49a35 35 0 0 1-24.75-59.75L388.17 379 198.43 189.26a35 35 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L247.93 618.24a34.89 34.89 0 0 1-24.75 10.25z" transform="translate(-188.18 -129.51)" fill="#000000"/></svg></button>'
        });

      }
  
  $(window).scroll(function() {


 if($('#ImageSequence0').isOnScreen()) {
   $('#pin1').removeClass('visit_sec');
   }else{
     $('#pin1').addClass('visit_sec');
   }
    
  
   if($('#canvas_1').isOnScreen()) {
        $('#pin2').removeClass('visit_sec');
      }else{
      $('#pin2').addClass('visit_sec');
      }
  
    if($(window).width()<= 768){
      if ($('.product-page-announcement-bar').isOnScreen()) {
        $('.sticky-main-button').removeClass('sticky_button');
      } else {
        $('.sticky-main-button').addClass('sticky_button');
      }
      
    }
    else{
      if ($('.header-bar-button').isOnScreen()) {
        $('.sticky-main-button').removeClass('sticky_button');
      } else {
        $('.sticky-main-button').addClass('sticky_button');
      }
    }
  });
  if ($('.header-bar-button').isOnScreen()) {
    $('.sticky-main-button').removeClass('sticky_button');
  } else {
    $('.sticky-main-button').addClass('sticky_button');
  }
});
$('.block-images-wrapper.desktop-wrapper').slick({
  dots: false,
  infinite: true,
  speed: 1000,
  fade: true,
  autoplay: true,
  autoplaySpeed: 5000
});





jQuery(document).on("click", ".buy_now-button", function(event){
  event.preventDefault();    
  var var_id=$('#ProductSelect-product-ready-rocker-page option:selected').val();
  var Page_bundle_product_type=$('.Page_bundle_product_type').attr('data-type');
  jQuery.post('/cart/add.js', {
    quantity: 1,id: var_id},null,"json").done(function(product) {
    if(Page_bundle_product_type == 'true'){
      $(".js-drawer-open-right .drawer--right").addClass('customclass');
      document.location.href = '/cart/checkout';  
    }
    else{
      theme.addToCartOk(product);
    }
  })
  .fail(function($xhr) {
    alert('Product has sold Out now');
  });
});
